import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, PipeTransform, Pipe, } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { RegistrationService } from '../../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Message } from 'primeng/components/common/api';
import { ValidateConfirmPassword } from '../../validators/confirmPassword.validator';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, FormControlDirective, FormControlName, MinLengthValidator } from '@angular/forms';
import { ChipsModule } from 'primeng/primeng';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { style } from '@angular/core/src/animation/dsl';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Component({
  selector: 'app-candidate-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class CandidateDashboardComponent implements OnInit {
  appStatusList: any[];
  admStatusList: any[];
  cols: any[];
  colsAdm: any[];
  display = false;
  displayDateChange = false;
  subjectSelectionDisplay = false;
  duplicateChallanList = [];
  selectedChallan: any;
  showInvalid: Boolean = false;
  appPaymentStatus = false;
  subjectTypeList: any = [];
  subjectList = [];
  dataList: any;
  dataListnew: any;
  defaultList: any = [];
  subjectSelectionForm: FormGroup;
  allsubjects = [];
  data: any;
  msgSubjectSelection: Message[] = [];
  errorMsgs: Message[] = [];
  admStatusId: any;
  selectedSubjectList: any;
  listLength: any;
  rowGroupMetadata: any;
  displayChangePass: boolean = false;
  changepassForm: FormGroup;
  token: any;
  show: boolean;
  cnfshow: boolean;
  oldshow: boolean;
  showAdmStatus = false;
  dateChangeReasonList = [];
  changeDateForm: FormGroup;
  minDateOfBirth: Date;
  maxDateOfBirth: Date;
  dateOfBirth: Date;
  maxDateOfBirthYear: number;
  minDateOfBirthYear: number;
  dateMask: any;
  value: any;
  storedDate: any;
  showFinancialAid = false;
  showsportsQuota = false;

  displayFamilyInfo: boolean = false;
  familyinfoForm: FormGroup;
  countryId: any;
  stateId: any;
  public allcountrylist = [];
  isOtherState: boolean = true;
  isOtherCity: boolean = true;
  otherOption: boolean = false;
  public stateList = [];
  public cityList = [];
  public districtList = [];
  public stateListPer = [];
  public cityListPer = [];
  public districtListPer = [];
  isOtherStatePerm: boolean = true;
  isOtherCityPerm: boolean = true;
  otherOptionPerm: boolean = false;
  pdfSrc: string;
  displayConfirmDialog: boolean = false;
  public occupationlist = [];
  public placeofstaylist = [];
  public relationlist = [];
  emailRegEx: any;
  public titleList = [];

  placeofstayOther: boolean;
  requiredplaceofstayOther: boolean = true;
  isfather: boolean = true;
  ismother: boolean = true;
  locaguardian: boolean = true;
  showdocuploadModal: boolean = false;

  fileToUpload: File = null;
  uploadUrl: string;
  uploadedFiles: any[] = [];
  input = new FormData();
  msgs: Message[] = [];
  userdetails: any;
  showscupload: boolean = false;
  showPhUpload: boolean = false;
  showCureg: boolean = false;
  showMigrationUpload: boolean = true;
  photo: any;
  sign: any;
  dob: any;
  marksheet: any;
  admitcard: any;
  migration: any;
  caste: any;
  equivalence: any;
  disability: any;
  showuploadedDocs: boolean = false;

  displayphoto: boolean = false;
  displaysign: boolean = false;
  displaydob: boolean = false;
  displaymarksheet: boolean = false;
  displayadmitcard: boolean = false;
  displaymigration: boolean = false;
  displaycaste: boolean = false;
  displayequivalence: boolean = false;
  displaydisability: boolean = false;
  displayphotoidstudent: boolean = false;
  displayphotoidmother: boolean = false;
  displayphotoidfather: boolean = false;

  msgInfo: Message[] = [];
  public genericList = [];
  msgPhotoUpload: Message[] = [];

  readonlyspectaclesnote: boolean = true;
  readonlyillnessnote: boolean = true;
  readonlyallergynote: boolean = true;
  readonlysurgerynote: boolean = true;
  readonlyotherhealthconditionnote: boolean = true;
  oneUser = false;
  public dateList = [];
  public slotList = [];

  public dayList = [];
  dayListBcom = [];
  displaygujratiadm: boolean = false;
  chkbx1: any;
  chkbx2: any;
  chkbx3: any;
  gujratiadmForm: FormGroup;
  displaygujratiadmForm: boolean = false;
  displayfatherdetailsForm: boolean = false;
  showdaylist: boolean = false;
  courseid: any;
  coursedetailid: any;
  hidegreenredbtn = false;
  financialdata: any;
  showgujaratiadmtype = false;
  displayGujAdmDialog: boolean = false;
  dayname: any;
  gujadmtype: any;
  disablegujform = false;
  public admsportsList = [];
  public awardlevelList = [];

  displayUploadPhoto: boolean = false;
  width: number;
  height: number;
  hideuploadandsubmit = false;
  displayPhotoInstruction = false;
  showhtwidth = false;

  disbledselect = true;
  displaysportsquotaadm: boolean = false;
  chkbx4: any;
  chkbx5: any;
  chkbx6: any;
  displaysportsquotaForm: boolean = false;
  sportsquotaForm: FormGroup;
  certyearList = [];
  showsportstype = false;
  displaySportsAdmDialog: boolean = false;
  displaysportslist = [];
  sportsadmtype: any;
  sportsdetailTable: any;
  filepath: any;
  sportscoursedetailid: any;
  disabesportsform = false;
  boardid: any;
  disbaleselectsubjectbtn = false;
  disblephotouploadbtn = false;

  docchkbx1: any;
  docchkbx2: any;
  docchkbx3: any;
  docchkbx4: any;
  docchkbx5: any;
  displaydocupload: boolean = false;
  photoidfather: any;
  photoidmother: any;
  photoidstudent: any;
  disabledocchk: boolean = false;
  boarrollnoforotherboard = false
  disableAdddonBtn = true;
  textfordocstatus: any;
  chkbx10: any;
  enabledocupload = true;
  enabledocuploadfatherdoc = false;
  enabledocuploadmotherdoc = false;

  step3LabelName: any;
  requiredFlag: boolean = true;
  mobRegEx = '^((\\+91-?)|0)?[0-9]{10}$';
  onlyNumberRegEx = "^[0-9]{12}$"
  dayListOnlyWednessday: any;
  greenButtonDisable = true;
  redButtonDisable = true;
  submitDisable = false;
  exInterestDisplay = false;
  eoiButtonDisplay = false;
  eoiChkboxOption = true;
  courseSession: any;
  courseName: any;
  eoiDialogSubmit = false;
  chkeoi: any;
  uncheck: any;
  eoiForm: FormGroup;
  eoiButtonName: any;
  courseAppNo: any;
  relatedTo: any;
  doseofVaccine: any;
  nameofVaccine: any;
  readonlyNotGetVaccine: boolean = true;
  otherVacFlg: boolean = false;
  public relationlistRelaredToOf = [];
  admStatusUploadDocMsg: boolean = false;
  marksheetDialogBoxT = false;
  marksheetDialogBoxF = false;
  migrationDialogBoxT = false;
  migrationDialogBoxF = false;
  migrationChkBox: boolean = false;
  marksheetChkBox: boolean = false;
  docStatusAprvdBttnDisable: boolean = false;
  individualAdmitCard: boolean = false;
  individualCaste: boolean = false;
  individualDisability: boolean = false;
  individualDob: boolean = false;
  individualEquivalence: boolean = false;
  individualMarksheet: boolean = false;
  individualMigration: boolean = false;
  individualPhoto: boolean = false;
  individualPhotoidfather: boolean = false;
  individualPhotoidmother: boolean = false;
  individualPhotoidstudent: boolean = false;
  individualSign: boolean = false;
  gujpaymentStatus: boolean = false;
  allchecked: boolean = false;

  selectedFileToShow: any[];
  colsFile: any[];
  colsMandatoryFile: any[];
  selectedFileToShowforMandatory: any[];
  docUploadDialog: boolean = false;
  mandatoryDialog: boolean = false;
  cityId: any;
  isOtherDistrictPerm: boolean = true;
  isOtherDistrict: boolean = true;

  // @ViewChild('divToScroll') divToScroll: ElementRef;
  constructor(private fb: FormBuilder, private registrationService: RegistrationService, private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.userdetails = JSON.parse(localStorage.getItem('userDetails'));
    // console.log(this.userdetails);
    // console.warn(this.userdetails);
    // if(this.userdetails.id===1600){
    // 	this.oneUser=true;
    // }
    let date = new Date;
    let currentyear = date.getFullYear();
    let startyear = currentyear - 5;
    let yearlength = startyear + 6;

    for (let i = startyear; i < yearlength; i++) {
      var obj = { "id": i, "name": i };
      this.certyearList.push(obj);
    }

    this.colsFile = [
      // { field: 'srl', header: 'Srl.' },
      { field: 'coursenm', header: 'Document Name' },
    ];
    this.colsMandatoryFile = [
      // { field: 'srl', header: 'Srl.' },
      { field: 'coursenm', header: 'Document Name' },
    ];

    this.emailRegEx = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    this.msgInfo = [];
    this.msgInfo.push({ severity: 'info', summary: 'Please Note :' });
    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '1. Sr. a - e is compulsory for all applicants.'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '2. Sr. f & g is compulsory for all applicants, as applicable.'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '3. Sr. h - k is only for applicants under the category as specified therein.'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '4. Applicants who have not received their Class XII original marksheet / pass certificate / migration certificate, as applicable, can scan & upload their attested net copy of the said documents.'
    // });
    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '5. All the Documents (except signature) must be <small>Original Scanned Copy</small>.'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '6. The file type extension must be in <small>.jpg</small> only.'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '7. <small>The file size of the signature should be within 100Kb and for other documents between 150kb to 250kb.</small>'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '8. The dimension of the signature should be <small>150px X 50px </small>(i.e. 150px in Width & 50px in Height). <a href="https://www.thebges.edu.in/wp-content/uploads/2020/08/Img2go.pdf" target="_blank"> Click here for help</a>.'
    // });

    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '9. You can visit <a href="https://www.resizepixel.com/" target="_blank">resizepixel.com</a> in your desktop if you need to resize your document before submitting. <a href="https://www.thebges.edu.in/wp-content/uploads/2020/08/Resizepixel.Com_.pdf" target="_blank"> Click here for help</a>.'
    // });
    // this.msgInfo.push({
    //   severity: 'info',
    //   detail:
    //     '10. You can also use <a href="https://play.google.com/store/apps/details?id=omkar.tenkale.pictoolsandroid" target="_blank">PicTools</a> app available for Android and Apple to resize documents. <a href="https://www.thebges.edu.in/wp-content/uploads/2020/08/PicTools.pdf" target="_blank"> Click here for help</a>.'
    // });

    this.msgInfo.push({
      severity: 'info',
      detail:
        '1) Serial No. a – e & k is compulsory for all Applicants.'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '2) Serial No. f & g is NOT applicable for Applicants with Single Parents or for deceased parent.'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '3) Serial No. h - j is only for Applicants who have applied for Admission under the specified Category.'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '<small style="color:red;font-weight:bold"> 4) The scanning of all documents must be done of Original Document only and not of the photocopy.</small>'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '5) Applicants from University other than Calcutta University, who have not received their Migration certificate, can upload the net-copy of their Migration, only for the verification purpose. Such Applicants will have to submit their Original Migration by <strong> 10th November 2024 </strong>as the same will be required for Calcutta University Registration.'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '6) You will need to scan and save each document as a separate file. For example, if you are uploading a scan copy of your Marksheet and your Age proof, you need to scan and save each one as a separate file. Be sure that your file names do not include any special characters.'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '7) Scanning needs to be done only in .JPG format only (.JPEG is not allowed).'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '8) Ensure that the file size of each document is not below 300 KB, and for faster upload, try to limit the file size below 10 MB.'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '9) <a target="_blank" href="https://thebges.edu.in/wp-content/uploads/2022/08/Photo-Upload-Instructions-2022-23.pdf">Please click here to read instructions regarding Applicants Photograph specification.</a>'
    });
    this.msgInfo.push({
      severity: 'info',
      detail:
        '10) In case you find difficulty in uploading your documents, please contact us at <a href="dv@thebges.edu.in ">dv@thebges.edu.in</a> , mentioning your Application number & mobile number along with the issue faced.'
    });



    this.genericList = [
      {
        'id': 'Yes',
        'name': 'Yes'
      },
      {
        'id': 'No',
        'name': 'No'
      }
    ];
    this.dateChangeReasonList = [
      {
        'id': 'Original Marksheet and Pass Certificate not received',
        'name': 'Original Marksheet and Pass Certificate not received.'
      }, {
        'id': 'Out-station Applicant. Ticket issues',
        'name': 'Out-station Applicant. Ticket issues.'
      }, {
        'id': 'Health issues',
        'name': 'Health issues'
      },
      {
        'id': 'Personal issues',
        'name': 'Personal issues'
      }
    ];
    this.titleList = [
      { id: 'Mr.', name: 'Mr.' },
      { id: 'Mrs.', name: 'Mrs.' },
      { id: 'Dr.', name: 'Dr.' },
      { id: 'Prof.', name: 'Prof.' },
      { id: 'Late', name: 'Late' }
    ];

    this.placeofstaylist = [
      {
        'id': 'Own',
        'name': 'Own'
      }, {
        'id': 'Paying Guest',
        'name': 'Paying Guest'
      }, {
        'id': 'Hostel',
        'name': 'Hostel'
      },
      {
        'id': 'Relatives',
        'name': 'Relatives'
      },
      {
        'id': 'Family Friends',
        'name': 'Family Friends'
      }
    ];

    //=======Add by A===========
    if (this.userdetails.sParent === 'Yes') {
      if (this.userdetails.fTitle !== null && this.userdetails.fTitle !== 'Late') {
        this.relationlistRelaredToOf = [
          {
            'id': 'Father',
            'name': 'Father'
          }
          // ,
          // {
          //   'id': 'Guardian',
          //   'name': 'Guardian'
          // }
        ];
        this.relationlist = [
          {
            'id': 'Father',
            'name': 'Father'
          },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
      else if (this.userdetails.fTitle === 'Late') {
        this.relationlistRelaredToOf = [

          {
            'id': 'Guardian',
            'name': 'Guardian'
          }
        ];
        this.relationlist = [
          // {
          //   'id': 'Father',
          //   'name': 'Father'
          // },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
      else if (this.userdetails.mTitle !== null && this.userdetails.mTitle !== 'Late') {
        this.relationlistRelaredToOf = [
          {
            'id': 'Mother',
            'name': 'Mother'
          }
          // , {
          //   'id': 'Guardian',
          //   'name': 'Guardian'
          // }
        ];
        this.relationlist = [
          {
            'id': 'Mother',
            'name': 'Mother'
          },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }

      else if (this.userdetails.mTitle === 'Late') {
        this.relationlistRelaredToOf = [
          {
            'id': 'Guardian',
            'name': 'Guardian'
          }
        ];
        this.relationlist = [
          // {
          //   'id': 'Mother',
          //   'name': 'Mother'
          // },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
    }
    // if (this.userdetails.sParent === 'No') {
    //   this.relationlistRelaredToOf = [
    //     {
    //       'id': 'Father',
    //       'name': 'Father'
    //     }, {
    //       'id': 'Mother',
    //       'name': 'Mother'
    //     }, {
    //       'id': 'Guardian',
    //       'name': 'Guardian'
    //     }
    //   ];
    // }
    if (this.userdetails.sParent === 'No') {
      if (this.userdetails.mTitle === 'Late' && this.userdetails.fTitle === 'Late') {
        this.relationlistRelaredToOf = [
          // {
          //   'id': 'Father',
          //   'name': 'Father'
          // },
          {
            'id': 'Guardian',
            'name': 'Guardian'
          }
        ];
        this.relationlist = [
          // {
          //   'id': 'Mother',
          //   'name': 'Mother'
          // },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
      else if (this.userdetails.fTitle !== 'Late' && this.userdetails.mTitle !== 'Late') {
        this.relationlistRelaredToOf = [
          {
            'id': 'Father',
            'name': 'Father'
          },
          {
            'id': 'Mother',
            'name': 'Mother'
          }
          // , {
          //   'id': 'Guardian',
          //   'name': 'Guardian'
          // }
        ];
        this.relationlist = [
          {
            'id': 'Father',
            'name': 'Father'
          },
          {
            'id': 'Mother',
            'name': 'Mother'
          },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
      else if (this.userdetails.fTitle === 'Late' && this.userdetails.mTitle !== 'Late') {
        this.relationlistRelaredToOf = [
          {
            'id': 'Mother',
            'name': 'Mother'
          }
          // , {
          //   'id': 'Guardian',
          //   'name': 'Guardian'
          // }
        ];
        this.relationlist = [
          {
            'id': 'Mother',
            'name': 'Mother'
          },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
      else if (this.userdetails.fTitle !== 'Late' && this.userdetails.mTitle === 'Late') {
        this.relationlistRelaredToOf = [
          {
            'id': 'Father',
            'name': 'Father'
          }
          // , {
          //   'id': 'Guardian',
          //   'name': 'Guardian'
          // }
        ];
        this.relationlist = [
          {
            'id': 'Father',
            'name': 'Father'
          },
          {
            'id': 'Other',
            'name': 'Other'
          }
        ];
      }
    }

    // =======Add by A==========

    this.dayListBcom = [
      { id: 1, name: 'Monday' },
      { id: 2, name: 'Tuesday' },
      { id: 4, name: 'Thursday' },
      { id: 5, name: 'Friday' }
    ]

    this.dayList = [
      { id: 1, name: 'Monday' },
      { id: 2, name: 'Tuesday' },
      { id: 3, name: 'Wednesday' },
      { id: 4, name: 'Thursday' },
      { id: 5, name: 'Friday' },
    ]

    this.dayListOnlyWednessday = [
      { id: 3, name: 'Wednesday' }
    ]

    // this.relatedTo = [
    //   { id: 'Father', name: 'Father' },
    //   { id: 'Mother', name: 'Mother' },
    //   { id: 'Gurdian', name: 'Gurdian' }
    // ]

    this.nameofVaccine = [
      { id: 'Covishield', name: 'Covishield' },
      { id: 'Covaxin', name: 'Covaxin' },
      { id: 'Sputnik', name: 'Sputnik' },
      { id: 'Pfizer', name: 'Pfizer' },
      { id: 'Moderna', name: 'Moderna' },
      { id: 'Other', name: 'Other' }
    ]

    this.doseofVaccine = [
      { id: 'No', name: 'No' },
      { id: '1st Dose Only', name: '1st Dose Only' },
      { id: '2nd Dose', name: '2nd Dose' },
      { id: 'Booster', name: 'Booster' }
    ]

    this.admstatus();

    const TODAY = new Date();
    const MONTH = TODAY.getMonth();
    const YEAR = TODAY.getFullYear();

    this.maxDateOfBirthYear = YEAR;
    this.minDateOfBirthYear = YEAR - 30;

    this.minDateOfBirth = new Date();
    this.minDateOfBirth.setMonth(MONTH);
    this.minDateOfBirth.setFullYear(this.minDateOfBirthYear);

    this.maxDateOfBirth = new Date();
    this.maxDateOfBirth.setMonth(MONTH);
    this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);

    this.dateOfBirth = this.maxDateOfBirth;
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    // console.log(this.token);


    this.msgSubjectSelection = [];
    this.msgSubjectSelection.push({ severity: 'info', summary: 'Please Note' });
    this.msgSubjectSelection.push({
      severity: 'info',
      detail: "i. Once the submission of Generic Elective subjects is done, you cannot change or edit the same."
    });
    this.msgSubjectSelection.push({
      severity: 'info',
      detail: 'ii. Please ensure to have passing marks in the selected GE Subject in case you have studied the subject in Class XII.'
    });
    this.msgSubjectSelection.push({
      severity: 'info',
      detail: 'iii. Applicants must ensure their eligibility for the Generic Electives selected by them, especially for B.Sc. applicants. Please refer to Eligibility criteria of B.Sc. courses for further details.'
    });
    this.msgSubjectSelection.push({
      severity: 'info',
      detail: 'iv. Choice of elective is subject to approval of the Vice Principal of the department, whose decision in this matter will be final.'
    });

    if (this.token.sportsQuota === 'Yes') {
      this.showsportsQuota = true;
    } else {
      this.showsportsQuota = false;
    }
    // console.log(this.token);
    // console.log(this.token.sportsQuota);
    if (this.token.community === 'Yes' && this.token.sportsQuota === 'No') {
      this.showFinancialAid = true;
      this.showsportsQuota = false;
      // this.gujpaymentStatus = true;
      this.cols = [
        { field: 'coursenm', header: 'Course Name' },
        { field: 'appno', header: 'Application Number' },
        { field: 'paymentdt', header: 'Payment Date' },
        { field: 'payment', header: 'Payment' },
        { field: 'meritlistStatus', header: 'Merit List Status' },
        // { field: 'expressionOfInterest', header: 'Expression Of Interest' },   //add by a
        // { field: 'financialaid', header: 'Gujarati Admission' },
        // { field: 'sportsqupta', header: 'Sports Quota Form' }

      ];
      // && this.token.paystatus === 'Complete' && this.token.meritlist === 'No'
      // } else if (this.token.community === 'No' && this.token.sportsQuota === 'Yes' && this.token.surgerynote === 'no' ) {    //add by JD
      //   this.showsportsQuota = true;
      //   this.cols = [
      //     { field: 'coursenm', header: 'Course Name' },
      //     { field: 'appno', header: 'Application Number' },
      //     { field: 'paymentdt', header: 'Payment Date' },
      //     { field: 'payment', header: 'Payment' },
      //     { field: 'meritlistStatus', header: 'Merit List Status' },
      // { field: 'sportsqupta', header: 'Sports Quota Admission' }

      //   ];
      // }else if (this.token.community === 'Yes' && this.token.sportsQuota === 'Yes' ) {    //add by JD
      //   this.showFinancialAid = true;
      //   this.showsportsQuota = false;
      //   this.cols = [
      //     { field: 'coursenm', header: 'Course Name' },
      //     { field: 'appno', header: 'Application Number' },
      //     { field: 'paymentdt', header: 'Payment Date' },
      //     { field: 'payment', header: 'Payment' },
      //     { field: 'meritlistStatus', header: 'Merit List Status' },
      // { field: 'financialaid', header: 'Gujarati Admission' },

      // ];
    }
    else {
      // this.gujpaymentStatus = false;
      this.showFinancialAid = false;
      this.showsportsQuota = false;
      this.cols = [
        // { field: 'challan', header: 'Challan' },
        { field: 'coursenm', header: 'Course Name' },
        { field: 'appno', header: 'Application Number' },
        // { field: 'applicationdt', header: 'Application Date' },
        // { field: 'paystatus', header: 'Payment Status' },
        { field: 'paymentdt', header: 'Payment Date' },
        { field: 'payment', header: 'Payment' },
        // { field: 'admissiontest', header: 'Admit Card' },
        // { field: 'expressionOfInterest', header: 'Expression Of Interest' },   //add by a
        { field: 'meritlistStatus', header: 'Merit List Status' },
        // { field: 'sportsqupta', header: 'Sports Quota Admission' } // comment by a

      ];
    }


    this.colsAdm = [
      { field: 'appno', header: 'Application Number' },
      { field: 'coursenm', header: 'Course Name' },
      // { field: 'subjectselection', header: 'Generic Elective Subject Selection' },
      { field: 'payment', header: 'Fees Payment' },
      { field: 'feespaydt', header: 'Fees Payment Date' },
      { field: 'family', header: 'Add-on Information' },
      { field: 'document', header: 'Upload Document' },

      //{ field: 'docvrfdttm', header: 'Document Submission Date' },
      { field: 'docvrfdttm', header: 'Document Approval Status' },
      { field: 'admissionform', header: 'Important Note' }
    ];


    this.registrationService.getDashboardCommon(localStorage.getItem('authToken'))
      .then(data => {
        // console.log(data);
        this.duplicateChallanList = data.paymentChllnList;
        this.occupationlist = data.occupationlist;
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });

    this.subjectSelectionForm = this.fb.group({
      subjectDetailInfo: this.fb.array([])
    });

    if (this.userdetails.mailingAddress != null) {
      this.enabledocupload = false;
    }
    if (this.userdetails.fTitle == 'Late' || this.userdetails.fTitle == null) {
      this.enabledocuploadfatherdoc = true;
    }
    if (this.userdetails.mTitle == 'Late' || this.userdetails.mTitle == null) {
      this.enabledocuploadmotherdoc = true;
    }

  }

  admstatus() {
    this.spinner.show();
    this.registrationService.getCourseWiseApplicationStatus(localStorage.getItem('authToken'))
      .then(data => {
        this.spinner.hide();
        // console.warn(data);
        // console.log(data);
        this.spinner.hide();
        this.appStatusList = data.appSatusList;
        // console.log(this.appStatusList);
        this.admStatusList = data.admSatusList;
        // this.paymentStatus = this.appStatusList[0].paystatus;
        // console.log(this.appStatusList[0].paystatus);
        if (this.admStatusList != undefined) {
          this.showAdmStatus = true;
        }
        this.updateRowGroupMetaData();

        // for (let i = 0; i < this.appStatusList.length; i++) { // add by jd
        //   if (this.appStatusList[i].paystatus == 'Complete') {
        //     this.gujpaymentStatus = true;
        //     this.cols = [
        //       { field: 'coursenm', header: 'Course Name' },
        //       { field: 'appno', header: 'Application Number' },
        //       { field: 'paymentdt', header: 'Payment Date' },
        //       { field: 'payment', header: 'Payment' },
        //       { field: 'meritlistStatus', header: 'Merit List Status' },
        //       // { field: 'expressionOfInterest', header: 'Expression Of Interest' },   //add by a
        //       { field: 'financialaid', header: 'Gujarati Admission' },
        //       //{ field: 'sportsqupta', header: 'Sports Quota Form' }

        //     ];
        //   }else{
        //     this.gujpaymentStatus = false;
        //     this.cols = [
        //       { field: 'coursenm', header: 'Course Name' },
        //       { field: 'appno', header: 'Application Number' },
        //       { field: 'paymentdt', header: 'Payment Date' },
        //       { field: 'payment', header: 'Payment' },
        //       { field: 'meritlistStatus', header: 'Merit List Status' },
        //       // { field: 'expressionOfInterest', header: 'Expression Of Interest' },   //add by a
        //       // { field: 'financialaid', header: 'Gujarati Admission' },
        //       //{ field: 'sportsqupta', header: 'Sports Quota Form' }

        //     ];
        //   }
        // }
        // console.log('actual :'+this.gujpaymentStatus)

        for (let i = 0; i < this.appStatusList.length; i++) { // add by a for eoi
          if (this.appStatusList[i].chkeoi == 'no') {
            this.eoiChkboxOption = true;
            this.eoiButtonName = "Register Expression of Interest";
            break;
          }
          if (this.appStatusList[i].chkeoi == 'yes') {
            this.eoiChkboxOption = false;
            this.eoiButtonName = "Withdraw Expression of Interest";
            break;
          }
        }

        // console.log(this.appStatusList);
        // for (let i = 0; i < this.appStatusList.length; i++) {
        //   if (this.appStatusList[i].paystatus == "Complete" && this.token.surgerynote == 'no' && this.token.sportsQuota == 'Yes' && this.token.community == 'No' ){
        //     this.showsportsQuota = true;
        //   }else{
        //     this.showsportsQuota = false;
        //   }
        // }

        // for (let i = 0; i < this.admStatusList.length; i++) {    //add by a for Complete Upload status show in admission status table
        //   // console.warn(this.admStatusList[i].documentstatus);
        //   if (this.admStatusList[i].documentstatus == 'COMPLETED') {
        //     this.admStatusUploadDocMsg = true;
        //     break;
        //     // console.warn('success'+'-'+this.admStatusList[i].documentstatus);
        //   }else{
        //     this.admStatusUploadDocMsg = false;
        //     // console.warn('error'+'-'+this.admStatusList[i].documentstatus);
        //   }
        // }

        //------------if meritlisted==yes  student will not update any information
        for (let i = 0; i < this.appStatusList.length; i++) {
          if (this.appStatusList[i].meritlist == 'Yes') {
            this.hideuploadandsubmit = true;
            localStorage.setItem('meritlisted', 'yes');
            break;
          }
          if (this.appStatusList[i].admin == 'Yes') {
            localStorage.setItem('admin', 'yes');
            break;
          }
        }
        // --------------------add by JD logic for add-on-info button and uploasection--------
        // console.log(this.admStatusList);
        for (let i = 0; i < this.admStatusList.length; i++) {
          if (this.admStatusList[i].admfeespd == 'no') {
            this.disableAdddonBtn = true;
            break;
          } else if (this.admStatusList[i].admfeespd == 'yes') {
            this.disableAdddonBtn = false;
          }

        }
        // --------------------------  end by JD ---------



        // add by a
        // for (let i = 0; i < this.admStatusList.length; i++) {
        //   if (this.admStatusList[i].feespaydt != '-') {
        //     this.disblephotouploadbtn = true;
        //     this.disableAdddonBtn = false;
        //     break;
        //   }
        //   else{
        //     this.disblephotouploadbtn = false;
        //     this.disableAdddonBtn = true;
        //   }
        // }

        // for (let i = 0; i < this.admStatusList.length; i++) {
        //   // console.log(this.admStatusList[i].documentstatus);
        //   // if (this.admStatusList[i].documentstatus === "Approved") {
        //   //   this.docStatusAprvdBttnDisable = true;
        //   //   //break;
        //   // }
        //   // else{
        //     this.docStatusAprvdBttnDisable = false;
        //   //}
        // }
        // add by a

      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
  }

  showPrintFormChallanDialog() {
    this.display = true;
  }

  printFormChallan(type) {
    let challanId = null;
    if (type === 'challan') {
      if (this.selectedChallan) {
        challanId = this.selectedChallan.name1;
      } else {
        this.showInvalid = true;
        return;
      }
    }
    this.spinner.show();
    this.registrationService
      .printFormChallan(localStorage.getItem('authToken'), type, challanId)
      .then(data => {
        this.display = false;
        //console.log(data.pdfLink);
        window.open(data.pdfLink);
        this.spinner.hide();
      });

  }

  payApplicationFees(c) {
    //alert(this.listLength);
    localStorage.setItem("challan", c);
    this.router.navigate(['admission/payment-information']);
    //this.router.navigate(['candidate/admissionfeespayment']);
  }

  selectSubject(id, courseid, feesdt, docstatus) {
    this.spinner.show();
    if (feesdt != '-') {
      this.disbaleselectsubjectbtn = true;
    }
    else {
      this.disbaleselectsubjectbtn = false;
    }

    // console.log(docstatus);
    this.docStatusAprvdBttnDisable = false;
    if (docstatus === "Approved") {
      this.docStatusAprvdBttnDisable = true;
    }

    this.subjectTypeList = [];
    this.admStatusId = id;
    this.registrationService.getSelectedSubject(localStorage.getItem('authToken'), this.admStatusId).then(res => {
      // console.log(res);
      this.selectedSubjectList = res;
      this.listLength = this.selectedSubjectList.subjectList;
      this.admstatus();
    });
    this.registrationService.getSubjectForSelection(localStorage.getItem('authToken'), courseid).then(data => {
      //console.log(data);
      this.dataList = data;
      this.removeMarks();
      let control = <FormArray>this.subjectSelectionForm.controls.subjectDetailInfo;
      this.allsubjects = [];
      if (this.dataList.status === 'success') {
        this.subjectSelectionDisplay = true;
        if (this.listLength.length > 0) {
          this.dataList.data.forEach((x, i) => {
            let subjects = [];
            x.dropList.forEach((item, index) => {
              subjects.push({
                id: item.id,
                name: item.name
              });
            })
            this.allsubjects.push({ a: subjects });
            control.push(
              this.fb.group({
                subjectTypeId: x.id,
                sujectType: x.name,
                subjectId: this.listLength[i].subjectId,
                subSelId: this.listLength[i].subSelId
              })
            );
          });
          this.spinner.hide();
        }
        else {
          this.dataList.data.forEach((x, i) => {
            let subjects = [];
            x.dropList.forEach((item, index) => {
              subjects.push({
                id: item.id,
                name: item.name
              });
            })
            this.allsubjects.push({ a: subjects });
            control.push(
              this.fb.group({
                subjectTypeId: x.id,
                sujectType: x.name,
                subjectId: 0
              })
            );
          });
          this.spinner.hide();
        }
        this.admstatus();
      }
      else {
        this.subjectSelectionDisplay = false;
        alert(this.dataList.msg);
        this.admstatus();
        this.spinner.hide();
      }

    });

  }

  addSubject() {
    const control = <FormArray>this.subjectSelectionForm.controls['subjectDetailInfo'];
    let newsubjectGroup: FormGroup = this.initItems();
    control.push(newsubjectGroup);
  }
  initItems(): FormGroup {
    return this.fb.group({
      subjectTypeId: [''],
      sujectType: ['', Validators.required],
      subjectId: new FormControl,
      subSelId: new FormControl
    });
  }
  removeMarks() {
    const control = <FormArray>this.subjectSelectionForm.controls['subjectDetailInfo'];
    for (let i = control.length; i >= 0; i--) {
      control.removeAt(i);
    }
  }

  checkRepeat(i, e) {
    const p = e.target.value;
    let subjectdata = [];
    subjectdata = this.subjectSelectionForm.value.subjectDetailInfo;
    for (let n = 0; n < subjectdata.length; n++) {
      if (n !== i) {
        if (subjectdata[n].subjectId == p) {
          e.target.value = 0;
          subjectdata[i].subjectId = 0;
          return false;
        }
      }
    }
  }

  savesubjectSelection() {
    this.data = this.subjectSelectionForm.value;
    this.spinner.show();
    const control = this.subjectSelectionForm.value.subjectDetailInfo;
    for (let i = 0; i < control.length; i++) {
      if (control[i].subjectId == 0 || control[i].subjectId == null) {
        this.errorMsgs = [];
        this.errorMsgs.push({
          severity: 'error',
          detail: 'Please select subject at row no.' + (1 + i)
        });
        this.spinner.hide();
        return false;
      }
      else {
        this.errorMsgs = [];
      }
    }
    this.registrationService.saveSubjectSelection(localStorage.getItem('authToken'), this.data, this.admStatusId).then(res => {
      this.spinner.hide();
      // console.log(res);
      alert(res.msg);
      this.admstatus();
      if (res.status == "success")
        this.subjectSelectionDisplay = false;
      else
        this.subjectSelectionDisplay = true;
    }, err => {
      this.spinner.hide();
    });
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.appStatusList) {
      for (let i = 0; i < this.appStatusList.length; i++) {
        let rowData = this.appStatusList[i];
        let challan = rowData.challan;
        if (i == 0) {
          this.rowGroupMetadata[challan] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.appStatusList[i - 1];
          let previousRowGroup = previousRowData.challan;
          if (challan === previousRowGroup)
            this.rowGroupMetadata[challan].size++;
          else
            this.rowGroupMetadata[challan] = { index: i, size: 1 };
        }
      }
    }
  }

  getChallanOrForm(challanno) {
    //alert(challanno);
    this.spinner.show();
    this.registrationService.getChallanOrForm(this.token.authToken, this.token.id, challanno).then(res => {
      //console.log(res);
      this.spinner.hide();
      if (res.status === 'success') {
        window.open(res.pdfLink, "_blank");
      }
      // else if (res.status === 'failure') {
      // 	alert(res.msg);
      // }
    });
  }
  openProcessPdf() {
    window.open('https://74.207.233.48:8080/HRCLADM_2018/resources/Reports/Application_procedure.pdf', "_blank");
  }

  getAdmitCard(courseid) {
    this.spinner.show();
    this.registrationService.getAdmitCard(this.token.authToken, this.token.id, courseid).then(res => {
      //	console.log(res);
      this.spinner.hide();
      if (res.status === 'success') {
        window.open(res.pdfLink, "_blank");
      }
    });
  }

  payAdmissionFees(c) {
    //alert(this.listLength);
    localStorage.setItem("cdid", c);
    this.router.navigate(['candidate/admissionfeespayment']);
  }

  viewFianancialAid(coursedetailsid, courseid) {
    this.spinner.show();
    this.registrationService.getFianancialAid(localStorage.getItem('authToken'), this.token.id, coursedetailsid, courseid)
      .then(res => {
        // console.log(res);
        this.spinner.hide();
        if (res.status === 'success') {
          window.open(res.pdfLink, "_blank");
        }
      }, error => {
        this.spinner.hide();
      });
  }

  /*------------------------------------------------ NEED TO REMOVE CODITION-----------------------------*/
  showFamilyInfoDialog() {
    // if(this.userdetails.id==1600){
    // 	this.displayConfirmDialog = true;
    // }
    this.chkbx10 = false;
    this.displayConfirmDialog = true;
  }



  accept = function (el) {
    this.spinner.show();
    this.displayConfirmDialog = false;
    //this.divToScroll.nativeElement.scrollTop = 0;
    this.getAdditionalLists();
    this.boardid = this.token.academicDetailInfo[0].boardId;
    this.familyinfoForm = this.fb.group({
      fmobno: new FormControl('', Validators.pattern('^[0-9]*$')),
      mmobno: new FormControl('', Validators.pattern('^[0-9]*$')),

      famoccupationid: new FormControl(null),
      motheroccupationid: new FormControl(null),
      // fatheremail: new FormControl('', [Validators.pattern(this.emailRegEx)]),
      // motheremail: new FormControl('', [Validators.pattern(this.emailRegEx)]),

      mailingAddress: new FormControl('', Validators.required),
      newcountryId: new FormControl(null, Validators.required),
      newcityId: new FormControl(null, Validators.required),
      othernewCity: new FormControl(null),
      newstateId: new FormControl(null, Validators.required),
      othernewState: new FormControl(null),
      newresipinno: new FormControl('', Validators.required),

      parmanentAddress: new FormControl('', Validators.required),
      countryId: new FormControl(null, Validators.required),
      cityId: new FormControl(null, Validators.required),
      resiStateId: new FormControl(null, Validators.required),
      otherState: new FormControl(null),
      otherCity: new FormControl(null),
      resiPinNo: new FormControl('', Validators.required),

      placeofstay: new FormControl(null, Validators.required),
      placestayconractno: new FormControl(''),
      placestayaddress: new FormControl(''),
      familydetails: new FormControl(null, Validators.required),
      otherguardianname: new FormControl(null),
      localguardianname: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z ]*$')]),
      localguardianoccupation: new FormControl(null, Validators.required),
      gttl: new FormControl(null, Validators.required),
      gmobno: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern('^[0-9]*$')]),
      localguardianaddress: new FormControl('', Validators.required),
      spectacles: new FormControl('No', Validators.required),
      illness: new FormControl('No', Validators.required),
      allergy: new FormControl('No', Validators.required),
      surgery: new FormControl('No', Validators.required),
      otherhealthcondition: new FormControl('No', Validators.required),
      spectaclesnote: new FormControl(''),
      illnessnote: new FormControl(''),
      allergynote: new FormControl(''),
      surgerynote: new FormControl(''),
      otherhealthconditionnote: new FormControl(''),

      alternativeemail: new FormControl(null, [Validators.pattern(this.emailRegEx)]),
      relatedto: new FormControl(null, Validators.required),
      infectedcovid19: new FormControl(null, Validators.required),
      vaccinated: new FormControl(null, Validators.required),
      vaccinename: new FormControl(null, Validators.required),
      donatedblood: new FormControl(null, Validators.required),
      donatingblood: new FormControl(null, Validators.required),
      othvaccinename: new FormControl(''),
      stdheight: new FormControl('', Validators.required),

      // boardroll1: new FormControl(''),
      // boardroll2: new FormControl(''),
      // schoolno: new FormControl(''),
      // centerno: new FormControl(''),
      // admintcardid: new FormControl(''),
      // registrationno: new FormControl(''),
      // indexno1: new FormControl(''),
      // indexno2: new FormControl(''),
      adhaarcardno: new FormControl('', [Validators.pattern(this.onlyNumberRegEx)]),
      resiDistrictId: new FormControl(null, Validators.required),
      otherresiDistrict: new FormControl(null, [Validators.pattern('^[A-Za-z ]*$')]),
      newDistrictId: new FormControl(null, Validators.required),
      othernewDistrict: new FormControl(null, [Validators.pattern('^[A-Za-z ]*$')]),
    });
    //this.familyinfoForm.get('boardroll1').disable();
    //this.familyinfoForm.get('boardroll2').disable();
    this.familyinfoForm.get('motheroccupationid').disable();
    this.familyinfoForm.get('famoccupationid').disable();

    this.notSingleParent();
    this.enableFatherdtls();
    this.enableMotherdtls();
    this.userdetails = JSON.parse(localStorage.getItem('userDetails'));
    if (this.userdetails.parmanentAddress != null) {
      // alert(this.userdetails.allergy);
      // console.warn(this.userdetails)
      this.familyinfoForm.patchValue(this.userdetails);

      this.getStateCity(this.userdetails.newcountryId, this.userdetails.newstateId, this.userdetails.newcityId);
      this.getStateCityPermanent(this.userdetails.countryId, this.userdetails.resiStateId, this.userdetails.cityId);
      if (this.userdetails.newstateId == -1) {
        this.enableOtherState();
      }
      if (this.userdetails.newcityId == -1) {
        this.enableOtherCity();
      }
      if (this.userdetails.resiStateId == -1) {
        this.enableOtherStatePermanent();
      }
      if (this.userdetails.cityId == -1) {
        this.enableOtherCityPermanent();
      }
      if (this.userdetails.resiDistrictId == -1) {
        this.enableOtherDistrictPermanent();
      }
      if (this.userdetails.newDistrictId == -1) {
        this.enableOtherDistrict();
      }
      // if (this.userdetails.placeofstay != 'Own') {
      //   this.otherplaceofstayEdit(this.userdetails.placeofstay);
      // }
      this.enableFatherdtls();
      this.enableMotherdtls();
      this.notSingleParent();
      ///this.enablespecnoteedit(this.userdetails.spectacles);
    }

    // Remove Appended
    // if(this.boardid==3){
    //   if(this.userdetails.boardroll1==null){
    //     let boardrollorg = this.token.academicDetailInfo[0].regno.replace(' ','');
    //     let boardrollorgarr = boardrollorg.split("");
    //     let newbordroll1 = boardrollorgarr[0] + boardrollorgarr[1]+ boardrollorgarr[2]+ boardrollorgarr[3]+ boardrollorgarr[4]+ boardrollorgarr[5];
    //     let newbordroll2 = boardrollorgarr[6] + boardrollorgarr[7]+ boardrollorgarr[8]+ boardrollorgarr[9];
    //     this.familyinfoForm.get('boardroll1').setValue(newbordroll1);
    //     this.familyinfoForm.get('boardroll2').setValue(newbordroll2);
    //   }
    //   else{
    //     this.familyinfoForm.get('boardroll1').setValue(this.userdetails.boardroll1);
    //     this.familyinfoForm.get('boardroll2').setValue(this.userdetails.boardroll2);
    //   }
    //   const registrationno = this.familyinfoForm.get('registrationno');
    //   registrationno.setValidators([Validators.required, Validators.minLength(1)]);
    //   registrationno.updateValueAndValidity();
    // }
    // else if(this.boardid==2){
    //   if(this.userdetails.boardroll1==null){
    //     this.familyinfoForm.get('boardroll1').setValue(this.token.academicDetailInfo[0].regno);
    //   }
    //   else{
    //     this.familyinfoForm.get('boardroll1').setValue(this.userdetails.boardroll1);
    //   }
    //   const indexno1 = this.familyinfoForm.get('indexno1');
    //   const indexno2 = this.familyinfoForm.get('indexno2');
    //   indexno1.setValidators([Validators.required, Validators.minLength(1)]);
    //   indexno2.setValidators([Validators.required, Validators.minLength(1)]);
    //   indexno1.updateValueAndValidity();
    //   indexno2.updateValueAndValidity();
    // }
    // else if(this.boardid==10){
    //   if(this.userdetails.boardroll1==null){
    //     this.familyinfoForm.get('boardroll1').setValue(this.token.academicDetailInfo[0].regno);
    //   }else{
    //     this.familyinfoForm.get('boardroll1').setValue(this.userdetails.boardroll1);
    //   }
    //   const schoolno = this.familyinfoForm.get('schoolno');
    //   const centerno = this.familyinfoForm.get('centerno');
    //   const admintcardid = this.familyinfoForm.get('admintcardid');
    //   schoolno.setValidators([Validators.required, Validators.minLength(1)]);
    //   centerno.setValidators([Validators.required, Validators.minLength(1)]);
    //   admintcardid.setValidators([Validators.required, Validators.minLength(1)]);
    //   schoolno.updateValueAndValidity();
    //   centerno.updateValueAndValidity();
    //   admintcardid.updateValueAndValidity();
    // }
    // else{
    //   this.boarrollnoforotherboard = true;
    //   if(this.userdetails.boardroll1==null){
    //     this.familyinfoForm.get('boardroll1').setValue(this.token.academicDetailInfo[0].regno);
    //   }
    //   else{
    //     this.familyinfoForm.get('boardroll1').setValue(this.userdetails.boardroll1);
    //   }
    //   //this.familyinfoForm.get('boardroll1').enable();
    // }


    this.displayFamilyInfo = true;
    this.spinner.hide();
  };
  reject = function () {
    this.displayConfirmDialog = false;
    this.displayFamilyInfo = false;
    // this.msgsResponse = [
    // 	{
    // 		severity: 'error',
    // 		summary: 'Rejected',
    // 		detail: 'You have rejected'
    // 	}
    // ];
  };

  getAdditionalLists() {
    this.registrationService
      .getAdditionalList(this.token.authToken)
      .subscribe(data => {
        //console.log(data);
        this.dataList = data;
        this.allcountrylist = this.dataList.allcountrylist;
        this.spinner.hide();
      });
  }

  getStateCity(x, y, z) {
    // //console.log("Present");

    this.countryId = x;
    this.stateId = y;
    this.cityId = z;
    // //console.log(x, y, z)
    if (x == null) {
      this.familyinfoForm.get('othernewState').setValue('');
      this.familyinfoForm.get('othernewCity').setValue('');
      this.familyinfoForm.get('othernewDistrict').setValue('');
      this.familyinfoForm.get('newstateId').setValue(null);
      this.familyinfoForm.get('newcityId').setValue(null);
      this.familyinfoForm.get('newDistrictId').setValue(null);
    }
    if (x == 1) {
      this.otherOption = false;
    } else {
      this.otherOption = true;
    }
    this.registrationService.getStateCity(x, y, z).subscribe(data => {
      this.dataList = data;
      // console.log(data)
      this.stateList = this.dataList.stateList;
      this.cityList = this.dataList.cityList;
      this.districtList = this.dataList.districtList;
      // console.log(this.districtList)
    });
  }
  enableOtherState() {
    const othernewState = this.familyinfoForm.get('othernewState');
    if (this.familyinfoForm.value.newstateId == '-1') {
      this.isOtherState = false;
      othernewState.setValidators([Validators.required]);
    } else {
      this.familyinfoForm.controls.othernewState.setValue(null);
      this.isOtherState = true;
      othernewState.clearValidators();
    }
    othernewState.updateValueAndValidity();
  }

  enableOtherCity() {
    const othernewCity = this.familyinfoForm.get('othernewCity');
    if (this.familyinfoForm.value.newcityId == '-1') {
      this.isOtherCity = false;
      othernewCity.setValidators([Validators.required]);
    } else {
      this.familyinfoForm.controls.othernewCity.setValue(null);
      this.isOtherCity = true;
      othernewCity.clearValidators();
    }
    othernewCity.updateValueAndValidity();
  }

  getStateCityPermanent(x, y, z) {
    // //console.log("Permanent");
    this.countryId = x;
    this.stateId = y;
    this.cityId = z;
    // //console.log(x, y, z)
    if (x == null) {
      this.familyinfoForm.get('otherState').setValue('');
      this.familyinfoForm.get('otherCity').setValue('');
      this.familyinfoForm.get('otherresiDistrict').setValue('');
      this.familyinfoForm.get('resiStateId').setValue(null);
      this.familyinfoForm.get('cityId').setValue(null);
      this.familyinfoForm.get('resiDistrictId').setValue(null);
    }
    if (x == 1) {
      this.otherOptionPerm = false;
    } else {
      this.otherOptionPerm = true;
    }
    this.registrationService.getStateCity(x, y, z).subscribe(data => {
      this.dataList = data;
      // console.log(data)
      this.stateListPer = this.dataList.stateList;
      this.cityListPer = this.dataList.cityList;
      this.districtListPer = this.dataList.districtList;
      // console.log(this.districtListPer)
    });
  }
  enableOtherStatePermanent() {
    const otherState = this.familyinfoForm.get('otherState');
    if (this.familyinfoForm.value.resiStateId == '-1') {
      this.isOtherStatePerm = false;
      otherState.setValidators([Validators.required]);
    } else {
      this.familyinfoForm.controls.otherState.setValue(null);
      this.isOtherStatePerm = true;
      otherState.clearValidators();
    }
    otherState.updateValueAndValidity();
  }

  enableOtherCityPermanent() {
    const otherCity = this.familyinfoForm.get('otherCity');
    if (this.familyinfoForm.value.cityId == '-1') {
      this.isOtherCityPerm = false;
      otherCity.setValidators([Validators.required]);
    } else {
      this.familyinfoForm.controls.otherCity.setValue(null);
      this.isOtherCityPerm = true;
      otherCity.clearValidators();
    }
    otherCity.updateValueAndValidity();
  }

  changeStatus(value: boolean) {
    if (value) {
      this.stateList = this.stateListPer;
      this.cityList = this.cityListPer;
      this.districtList = this.districtListPer;
      // console.log(this.districtList)

      this.familyinfoForm.controls.mailingAddress.setValue(this.familyinfoForm.value.parmanentAddress);
      this.familyinfoForm.controls.newcountryId.setValue(this.familyinfoForm.value.countryId);
      this.familyinfoForm.controls.newstateId.setValue(this.familyinfoForm.value.resiStateId);
      this.familyinfoForm.controls.newcityId.setValue(this.familyinfoForm.value.cityId);
      this.familyinfoForm.controls.othernewState.setValue(this.familyinfoForm.value.otherState);
      this.familyinfoForm.controls.othernewCity.setValue(this.familyinfoForm.value.otherCity);
      this.familyinfoForm.controls.newresipinno.setValue(this.familyinfoForm.value.resiPinNo);
      this.familyinfoForm.controls.newDistrictId.setValue(this.familyinfoForm.value.resiDistrictId);
      this.familyinfoForm.controls.othernewDistrict.setValue(this.familyinfoForm.value.otherresiDistrict);
      if (this.familyinfoForm.value.otherState != '') {
        this.enableOtherState();
      }
      if (this.familyinfoForm.value.otherCity != '') {
        this.enableOtherCity();
      }
      if (this.familyinfoForm.value.otherresiDistrict != '') {
        this.enableOtherDistrict();
      }
    }
    else {
      this.familyinfoForm.controls.mailingAddress.setValue('');
      this.familyinfoForm.controls.newcountryId.setValue(null);
      this.familyinfoForm.controls.newstateId.setValue(null);
      this.familyinfoForm.controls.newcityId.setValue(null);
      this.familyinfoForm.controls.othernewState.setValue('');
      this.familyinfoForm.controls.othernewCity.setValue('');
      this.familyinfoForm.controls.newresipinno.setValue('');
    }
  }

  submitFamilyInfo() {
    // console.log(this.familyinfoForm.value)
    if (this.familyinfoForm.valid) {
      // console.log(this.familyinfoForm.value);
      this.spinner.show();
      this.registrationService
        .submitFamilyInfo(
          this.token.authToken,
          this.familyinfoForm.value
        )
        .subscribe(data => {
          this.dataList = data;
          // console.log(this.dataList);
          if (this.dataList.status === 'success') {
            this.spinner.hide();
            this.displayFamilyInfo = false;
            this.chkbx10 = false;
            localStorage.setItem('userDetails', JSON.stringify(this.dataList.user));
            alert("Add-on Information saved");
            this.enabledocupload = false;
            this.admstatus();
          }
        });
    } else {
      //console.log('Form Not Submitted!');
      //console.log(this.familyinfoForm);
      Object.keys(this.familyinfoForm.controls).forEach(ctrl => {
        this.familyinfoForm.controls[ctrl].markAsDirty();
        window.scrollTo(0, 0);
      });
    }

  }
  getAdmChallan(cdid) {
    //alert(challanno);
    this.spinner.show();
    this.registrationService.getadmchallan(this.token.authToken, cdid).then(res => {
      //	console.log(res);
      this.spinner.hide();
      if (res.status === 'Success') {
        window.open(res.webLink, "_blank");
      }
      // else if (res.status === 'failure') {
      // 	alert(res.msg);
      // }
    });
  }
  //avoidSpace on email roll no
  avoidSpace(event) {
    let k = event.keyCode;
    if (k == 32) return false;
  }
  otherplaceofstay(e) {
    const otherplaceofstaycontact = this.familyinfoForm.get('placestayconractno');
    const otherplaceofstayaddress = this.familyinfoForm.get('placestayaddress');
    if (e.target.value == 'Own') {
      this.placeofstayOther = true;
      this.requiredplaceofstayOther = true;
      otherplaceofstaycontact.clearValidators();
      otherplaceofstayaddress.clearValidators();
      this.familyinfoForm.get('placestayconractno').setValue('');
      this.familyinfoForm.get('placestayaddress').setValue('');
    } else if (e.target.value == 'Hostel' || e.target.value == 'Paying Guest') {
      this.placeofstayOther = false;
      this.requiredplaceofstayOther = true;
      otherplaceofstaycontact.clearValidators();
      otherplaceofstayaddress.clearValidators();
      // this.familyinfoForm.get('placestayconractno').setValue('');
      // this.familyinfoForm.get('placestayaddress').setValue('');
    } else {
      this.placeofstayOther = false;
      this.requiredplaceofstayOther = false;
      otherplaceofstaycontact.setValidators([Validators.required]);
      otherplaceofstayaddress.setValidators([Validators.required]);
    }

    otherplaceofstayaddress.updateValueAndValidity();
    otherplaceofstaycontact.updateValueAndValidity();
  }

  otherplaceofstayEdit(placeofstay) {
    const otherplaceofstaycontact = this.familyinfoForm.get('placestayconractno');
    const otherplaceofstayaddress = this.familyinfoForm.get('placestayaddress');
    if (placeofstay == 'Own') {
      // this.placeofstayOther = false;
      // otherplaceofstaycontact.setValidators([Validators.required, Validators.minLength(10)]);
      // otherplaceofstayaddress.setValidators([Validators.required]);
      this.placeofstayOther = true;
      this.requiredplaceofstayOther = true;
      otherplaceofstaycontact.clearValidators();
      otherplaceofstayaddress.clearValidators();
      this.familyinfoForm.get('placestayconractno').setValue('');
      this.familyinfoForm.get('placestayaddress').setValue('');
    } else if (placeofstay == 'Hostel' || placeofstay == 'Paying Guest') {
      this.placeofstayOther = false;
      this.requiredplaceofstayOther = true;
      otherplaceofstaycontact.clearValidators();
      otherplaceofstayaddress.clearValidators();
      // this.familyinfoForm.get('placestayconractno').setValue('');
      // this.familyinfoForm.get('placestayaddress').setValue('');
    } else {
      // this.placeofstayOther = true;
      // otherplaceofstaycontact.clearValidators();
      // otherplaceofstayaddress.clearValidators();
      this.placeofstayOther = false;
      this.requiredplaceofstayOther = false;
      otherplaceofstaycontact.setValidators([Validators.required]);
      otherplaceofstayaddress.setValidators([Validators.required]);
    }
    otherplaceofstayaddress.updateValueAndValidity();
    otherplaceofstaycontact.updateValueAndValidity();
  }

  enableFatherdtls() {
    const fathermobile = this.familyinfoForm.get('fmobno');
    const fatheroccupation = this.familyinfoForm.get('famoccupationid');
    if (this.userdetails.sParent === 'Yes' && this.userdetails.fTitle != null && this.userdetails.fTitle != 'Late') {
      this.isfather = false;
      this.familyinfoForm.get('famoccupationid').enable();
      fathermobile.setValidators([Validators.required, Validators.minLength(10), Validators.pattern('^[0-9]*$')]);
      fatheroccupation.setValidators([Validators.required]);
    }
    fathermobile.updateValueAndValidity();
    fatheroccupation.updateValueAndValidity();
  }

  enableMotherdtls() {
    const mothermobile = this.familyinfoForm.get('mmobno');
    const motheroccupation = this.familyinfoForm.get('motheroccupationid');
    if (this.userdetails.sParent === 'Yes' && this.userdetails.mTitle != null && this.userdetails.mTitle != 'Late') {
      this.ismother = false;
      this.familyinfoForm.get('motheroccupationid').enable();
      mothermobile.setValidators([Validators.required, Validators.minLength(10)]);
      motheroccupation.setValidators([Validators.required]);
    }
    mothermobile.updateValueAndValidity();
    motheroccupation.updateValueAndValidity();
  }

  notSingleParent() {
    const fathermobile = this.familyinfoForm.get('fmobno');
    const fatheroccupation = this.familyinfoForm.get('famoccupationid');
    const mothermobile = this.familyinfoForm.get('mmobno');
    const motheroccupation = this.familyinfoForm.get('motheroccupationid');

    //&& this.userdetails.mTitle !='Late'  && this.userdetails.fTitle !='Late')
    if (this.userdetails.sParent === 'No' && this.userdetails.mTitle != 'Late') {
      this.ismother = false;
      this.familyinfoForm.get('motheroccupationid').enable();
      mothermobile.setValidators([Validators.required, Validators.minLength(10), Validators.pattern('^[0-9]*$')]);
      motheroccupation.setValidators([Validators.required]);
    }
    if (this.userdetails.sParent === 'No' && this.userdetails.fTitle != 'Late') {
      this.isfather = false;
      this.familyinfoForm.get('famoccupationid').enable();
      fathermobile.setValidators([Validators.required, Validators.minLength(10), Validators.pattern('^[0-9]*$')]);
      fatheroccupation.setValidators([Validators.required]);
    }
    mothermobile.updateValueAndValidity();
    motheroccupation.updateValueAndValidity();
    fathermobile.updateValueAndValidity();
    fatheroccupation.updateValueAndValidity();
  }

  enableLocalGuardian(e) {
    //alert(e.target.value);
    const otherguardian = this.familyinfoForm.get('otherguardianname');
    if (e.target.value == 'Other') {
      this.locaguardian = false;
      otherguardian.setValidators([Validators.required]);
      this.familyinfoForm.get('gttl').setValue(null);
      this.familyinfoForm.get('localguardianname').setValue('');
      this.familyinfoForm.get('gmobno').setValue('');
      this.familyinfoForm.get('localguardianoccupation').setValue(null);
      this.familyinfoForm.get('localguardianaddress').setValue('');
    }
    else if (e.target.value == 'Father') {
      this.locaguardian = true;
      this.familyinfoForm.get('otherguardianname').setValue('');

      this.familyinfoForm.get('gttl').setValue(this.userdetails.fTitle);
      this.familyinfoForm.get('localguardianname').setValue(this.userdetails.fatherName);
      this.familyinfoForm.get('gmobno').setValue(this.familyinfoForm.value.fmobno);
      this.familyinfoForm.get('localguardianoccupation').setValue(this.familyinfoForm.value.famoccupationid);
      this.familyinfoForm.get('localguardianaddress').setValue(this.familyinfoForm.value.parmanentAddress);
    }
    else if (e.target.value == 'Mother') {
      this.locaguardian = true;
      this.familyinfoForm.get('otherguardianname').setValue('');

      this.familyinfoForm.get('gttl').setValue(this.userdetails.mTitle);
      this.familyinfoForm.get('localguardianname').setValue(this.userdetails.motherName);
      this.familyinfoForm.get('gmobno').setValue(this.familyinfoForm.value.mmobno);
      this.familyinfoForm.get('localguardianoccupation').setValue(this.familyinfoForm.value.motheroccupationid);
      this.familyinfoForm.get('localguardianaddress').setValue(this.familyinfoForm.value.parmanentAddress);
    }
    otherguardian.updateValueAndValidity();
  }

  enablespecnote() {
    const spectaclesnote = this.familyinfoForm.get('spectaclesnote');
    if (this.familyinfoForm.value.spectacles === 'Yes') {
      this.readonlyspectaclesnote = false;
      spectaclesnote.setValidators([Validators.required]);
    }
    else {
      this.readonlyspectaclesnote = true;
      spectaclesnote.clearValidators();
      this.familyinfoForm.get('spectaclesnote').setValue('');
    }
    spectaclesnote.updateValueAndValidity();
  }

  enableillness() {
    const illnessnote = this.familyinfoForm.get('illnessnote');
    if (this.familyinfoForm.value.illness === 'Yes') {
      this.readonlyillnessnote = false;
      illnessnote.setValidators([Validators.required]);
    }
    else {
      this.readonlyillnessnote = true;
      illnessnote.clearValidators();
      this.familyinfoForm.get('illnessnote').setValue('');
    }
    illnessnote.updateValueAndValidity();
  }

  enableallergy() {
    const allergynote = this.familyinfoForm.get('allergynote');
    if (this.familyinfoForm.value.allergy === 'Yes') {
      this.readonlyallergynote = false;
      allergynote.setValidators([Validators.required]);
    }
    else {
      this.readonlyallergynote = true;
      allergynote.clearValidators();
      this.familyinfoForm.get('allergynote').setValue('');
    }
    allergynote.updateValueAndValidity();
  }

  enablesurgery() {
    const surgerynote = this.familyinfoForm.get('surgerynote');
    if (this.familyinfoForm.value.surgery === 'Yes') {
      this.readonlysurgerynote = false;
      surgerynote.setValidators([Validators.required]);
    }
    else {
      this.readonlysurgerynote = true;
      surgerynote.clearValidators();
      this.familyinfoForm.get('surgerynote').setValue('');
    }
    surgerynote.updateValueAndValidity();
  }

  enablehealthcondition(e) {
    const otherhealthconditionnote = this.familyinfoForm.get('otherhealthconditionnote');
    if (this.familyinfoForm.value.otherhealthcondition === 'Yes') {
      this.readonlyotherhealthconditionnote = false;
      otherhealthconditionnote.setValidators([Validators.required]);
    }
    else {
      this.readonlyotherhealthconditionnote = true;
      otherhealthconditionnote.clearValidators();
      this.familyinfoForm.get('otherhealthconditionnote').setValue('');
    }
    otherhealthconditionnote.updateValueAndValidity();
  }

  openProcedure() {
    window.open("https://thebges.edu.in/wp-content/uploads/2024/09/PG-PROCESS-AFTER-ML-24-25.pdf");
  }

  printAdmissionForm(cdid) {
    this.spinner.show();
    this.registrationService.getadmForm(this.token.authToken, cdid).then(res => {
      // console.log(res);
      this.spinner.hide();
      if (res.status === 'success') {
        window.open(res.pdfLink, "_blank");
      }
      // else if (res.status === 'failure') {
      // 	alert(res.msg);
      // }
    });
  }
  /*------------------------------------------------ NEED TO REMOVE CODITION-----------------------------*/
  showDocUploadDialog() {
    //if(this.userdetails.id==1600){
    this.docchkbx1 = false; this.docchkbx2 = false; this.docchkbx3 = false; this.docchkbx4 = false; this.docchkbx5 = false;
    this.allchecked = false;
    this.disabledocchk = false;
    this.displaydocupload = false;
    let boardid = this.userdetails.academicDetailInfo[0].boardId;
    this.showdocuploadModal = true;

    if (this.userdetails.categoryId != 1) {
      this.showscupload = true;
    }
    if (this.userdetails.handicapped == 'Yes') {
      this.showPhUpload = true;
    }
    if (boardid == 9) {
      this.showMigrationUpload = false;
    }
    if (this.userdetails.academicDetailInfo[0].prevadmitted == 'YES') {
      this.showCureg = true;
    }

    // add by a adm status

    //for (let i = 0; i < this.admStatusList.length; i++) { // add by a
    // console.warn("markshit "+this.admStatusList[0].marksheetnotreceived);
    // console.warn("migration "+this.admStatusList[0].migrationnotreceived);
    if (this.admStatusList[0].marksheetnotreceived == 'no') {
      this.marksheetChkBox = false;
      // console.warn(this.admStatusList[0].marksheetnotreceived);
      // break;
    }
    else if (this.admStatusList[0].marksheetnotreceived == 'yes') {
      this.marksheetChkBox = true;
      // console.warn(this.admStatusList[0].marksheetnotreceived);
      // break;
    }

    if (this.admStatusList[0].migrationnotreceived == 'no') {
      this.migrationChkBox = false;
      // break;
    }
    else if (this.admStatusList[0].migrationnotreceived == 'yes') {
      this.migrationChkBox = true;

      // break;
    }
    //}


    // add by a adm status

    this.showDocuments();
    //}
  }

  myUploader(event, flg): void {
    if (event.files.length == 0) {
      // console.log('No file selected.');
      return;
    }
    else {
      this.input = new FormData();
      var fileToUpload = event.files[0];
      this.input.append("file", fileToUpload);

      let img = new Image()
      img.src = window.URL.createObjectURL(event.files[0])

      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
      }
      setTimeout(() => {
        // if(this.width<155 ){
        //   this.showhtwidth= true;
        //   alert("Photo width is less than 155 pixel limit. Please resize your photo and try again.")
        // }
        // else if(this.width>175){
        //   this.showhtwidth= true;
        //   alert("Photo width exceeds 175 pixel limit. Please resize your photo and try again.")
        // }
        // else if(this.height<210 ){
        //   this.showhtwidth= true;
        //   alert("Photo height is less than 210 pixel limit. Please resize your photo and try again.")
        // }
        // else if(this.height>230 ){
        //   this.showhtwidth= true;
        //   alert("Photo height exceeds 230 pixel limit. Please resize your photo and try again.")
        // }
        // else{
        this.showhtwidth = false;
        this.spinner.show();
        this.registrationService.docupload(this.input, flg, this.userdetails.id).then(res => {
          this.spinner.hide();
          this.dataList = res;
          // console.log(res);
          // this.msgs = [];
          // this.msgs.push({
          //   severity: 'success',
          //   summary: this.dataList.message
          // });
          alert(this.dataList.message);
          // const dltid = this.dataList.dltid;
          // const mask = this.dataList.mask;
          // const mobno = this.dataList.mobno;
          // const pw = this.dataList.pw;
          // const un = this.dataList.un;
          // const sub = this.dataList.sub;
          // const name = this.dataList.name;
          // const emlbody = this.dataList.emlbody;
          // const emlpw = this.dataList.emlpw;
          // const emlsendto = this.dataList.emlsendto;
          // const emlsub = this.dataList.emlsub;
          // const emlun = this.dataList.emlun;
          // this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
          //   console.log('SMS sent successfully:', response);
          // })
          //   .catch(error => {
          //     console.log(error.message);
          //   });
          // if (this.dataList.name != '-') {
          //   this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
          //     console.log('SMS sent successfully:', response);
          //   })
          // } else {
          //   console.log(this.dataList.msg);
          // }

          this.showDocuments();
        }, error => {
          this.spinner.hide();
          alert('Something weent wrong.Please try again');
        })
        // }
      }, 500)
    }
  }

  myUploadersign(event, flg): void {
    if (event.files.length == 0) {
      // console.log('No file selected.');
      return;
    }
    else {
      this.input = new FormData();
      var fileToUpload = event.files[0];
      this.input.append("file", fileToUpload);

      let img = new Image()
      img.src = window.URL.createObjectURL(event.files[0])

      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
      }
      setTimeout(() => {
        // if(this.width!=175 ){
        //   //this.showhtwidth= true;
        //   alert("Signature width should be 175 pixel. Please resize your photo and try again.")
        // }
        // else if(this.height!=50){
        //   //this.showhtwidth= true;
        //   alert("Signature height should be 45 pixel . Please resize your photo and try again.")
        // }
        // else{
        this.showhtwidth = false;
        this.spinner.show();
        this.registrationService.docupload(this.input, flg, this.userdetails.id).then(res => {
          this.spinner.hide();
          this.dataList = res;
          //console.log(res);
          // this.msgs = [];
          // this.msgs.push({
          //   severity: 'success',
          //   summary: this.dataList.message
          // });
          alert(this.dataList.message);

          // const dltid = this.dataList.dltid;
          // const mask = this.dataList.mask;
          // const mobno = this.dataList.mobno;
          // const pw = this.dataList.pw;
          // const un = this.dataList.un;
          // const sub = this.dataList.sub;
          // const name = this.dataList.name;
          // const emlbody = this.dataList.emlbody;
          // const emlpw = this.dataList.emlpw;
          // const emlsendto = this.dataList.emlsendto;
          // const emlsub = this.dataList.emlsub;
          // const emlun = this.dataList.emlun;
          // this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
          //   console.log('SMS sent successfully:', response);
          // })
          //   .catch(error => {
          //     console.log(error.message);
          //   });
          // if (this.dataList.name != '-') {
          //   this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
          //     console.log('SMS sent successfully:', response);
          //   })
          // } else {
          //   console.log(this.dataList.msg);
          // }
          this.showDocuments();
        }, error => {
          this.spinner.hide();
          alert('Something weent wrong.Please try again');
        })
        // }
      }, 500)
    }
  }

  myUploadergeneric(event, flg) {
    if (event.files.length == 0) {
      // console.log('No file selected.');
      return;
    }
    else {
      this.input = new FormData();
      // if(flg!='sign'){
      //   if(event.files[0].size<150000){
      //     alert('File size should be within 150kb to 250kb');
      //     return false;
      //   }
      // }

      var fileToUpload = event.files[0];
      this.input.append("file", fileToUpload);
      this.spinner.show();
      this.registrationService.docupload(this.input, flg, this.userdetails.id).then(res => {
        this.spinner.hide();
        this.dataList = res;
        //console.log(res);
        // this.msgs = [];
        // this.msgs.push({
        //   severity: 'success',
        //   summary: this.dataList.message
        // });
        alert(this.dataList.message);

        // const dltid = this.dataList.dltid;
        // const mask = this.dataList.mask;
        // const mobno = this.dataList.mobno;
        // const pw = this.dataList.pw;
        // const un = this.dataList.un;
        // const sub = this.dataList.sub;
        // const name = this.dataList.name;
        // const emlbody = this.dataList.emlbody;
        // const emlpw = this.dataList.emlpw;
        // const emlsendto = this.dataList.emlsendto;
        // const emlsub = this.dataList.emlsub;
        // const emlun = this.dataList.emlun;
        // this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
        //   console.log('SMS sent successfully:', response);
        // })
        //   .catch(error => {
        //     console.log(error.message);
        //   });
        // if (this.dataList.name != '-') {
        //   this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
        //     console.log('SMS sent successfully:', response);
        //   })
        // } else {
        //   console.log(this.dataList.msg);
        // }
        this.showDocuments();
      }, error => {
        this.spinner.hide();
        alert('Something weent wrong.Please try again');
      })
    }
  }

  myUploadersports(event, flg, index, id): void {
    //alert(flg);
    // console.log('My File upload', event);
    if (event.files.length == 0) {
      // console.log('No file selected.');
      return;
    }
    const control = this.sportsquotaForm.value.sportsDetails;
    const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
    this.input = new FormData();
    var fileToUpload = event.files[0];
    this.input.append("file", fileToUpload);
    this.registrationService.docupload(this.input, flg, id).then(res => {
      this.dataList = res;
      // const dltid = this.dataList.dltid;
      // const mask = this.dataList.mask;
      // const mobno = this.dataList.mobno;
      // const pw = this.dataList.pw;
      // const un = this.dataList.un;
      // const sub = this.dataList.sub;
      // const name = this.dataList.name;
      // const emlbody = this.dataList.emlbody;
      // const emlpw = this.dataList.emlpw;
      // const emlsendto = this.dataList.emlsendto;
      // const emlsub = this.dataList.emlsub;
      // const emlun = this.dataList.emlun;
      // this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
      //   console.log('SMS sent successfully:', response);
      // })
      //   .catch(error => {
      //     console.log(error.message);
      //   });
      // if (this.dataList.name != '-') {
      //   this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
      //     console.log('SMS sent successfully:', response);
      //     controlArray.controls[index].get('filename').setValue(this.dataList.file);
      //   })
      // } else {
      //   console.log(this.dataList.msg);
      // }

      // console.log(res);
      // if (this.dataList.status == 'success') {
      //   controlArray.controls[index].get('filename').setValue(this.dataList.file);
      // }
      //console.log(res);
      this.msgs = [];
      this.msgs.push({
        severity: 'success',
        summary: this.dataList.message
      });
    }, error => {
      this.spinner.hide();
      alert('Something weent wrong.Please try again');
    })
  }


  onUpload(event): void {
    // console.log("onUpload");

    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }

  }

  onBeforeSend(event): void {
    // console.log("onBeforeSend");
    //event.xhr.setRequestHeader('Authorization', 'Bearer ' + abp.auth.getToken());
  }

  showDocuments() {
    this.spinner.show();
    this.registrationService.showdoc(this.userdetails.id).then(res => {
      // console.log(res);
      this.spinner.hide();
      // ----------------------- add by JD --------------
      if (res.status == 'success') {
        // const dltid = this.dataList.dltid;
        // const mask = this.dataList.mask;
        // const mobno = this.dataList.mobno;
        // const pw = this.dataList.pw;
        // const un = this.dataList.un;
        // const sub = this.dataList.sub;
        // const name = this.dataList.name;
        // const emlbody = this.dataList.emlbody;
        // const emlpw = this.dataList.emlpw;
        // const emlsendto = this.dataList.emlsendto;
        // const emlsub = this.dataList.emlsub;
        // const emlun = this.dataList.emlun;
        // this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
        //   console.log('SMS sent successfully:', response);
        // })
        //   .catch(error => {
        //     console.log(error.message);
        //   });
        // if (res.name != '-') {
        //   this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
        //     console.log('SMS sent successfully:', response);
        //   })
        // } else {
        //   console.log(res.msg);
        // }
        const splitedPhoto = res.photo.split('~!~');
        const splitedSign = res.sign.split('~!~');
        const splitedDob = res.dob.split('~!~');
        const splitedMarksheet = res.marksheet.split('~!~');
        const splitedMigration = res.migration.split('~!~');
        const splitedCaste = res.caste.split('~!~');
        const splitedEquivalence = res.equivalence.split('~!~');
        const splitedDisability = res.disability.split('~!~');
        const splitedPhotoidfather = res.photoidfather.split('~!~');
        const splitedPhotoidmother = res.photoidmother.split('~!~');
        const splitedPhotoidstudent = res.photoidstudent.split('~!~');
        const splitedadmtCard = res.admitcard.split('~!~');

        if (splitedPhoto[0] != '-' || splitedSign[0] != '-' || splitedDob[0] != '-' || splitedMarksheet[0] != '-' || splitedMigration[0] != '-' || splitedCaste[0] != '-' || splitedEquivalence[0] != '-' || splitedDisability[0] != '-' || splitedPhotoidfather[0] != '-' || splitedPhotoidmother[0] != '-' || splitedPhotoidstudent[0] != '-' || splitedadmtCard[0] != '-') {
          this.docchkbx1 = true; this.docchkbx2 = true; this.docchkbx3 = true; this.docchkbx4 = true; this.docchkbx5 = true;
          this.displaydocupload = true;
          this.disabledocchk = true;
          this.allchecked = true;
        }

        if (this.userdetails.adminlogin === 1) { // if part Of Admin
          this.docStatusAprvdBttnDisable = false;
          this.individualPhoto = false;



          this.displayphoto = true;
          const splitedPhoto = res.photo.split('~!~');
          if (splitedPhoto[0] != '-') {
            this.displayphoto = true;
            this.photo = splitedPhoto[0];
          } else if (splitedPhoto[0] === '-') {
            this.displayphoto = false;
          }

          this.displaysign = true;
          const splitedSign = res.sign.split('~!~');
          if (splitedSign[0] != '-') {
            this.displaysign = true;
            this.sign = splitedSign[0];
          } else if (splitedSign[0] === '-') {
            this.displaysign = false;
          }

          this.displaydob = true;
          const splitedDob = res.dob.split('~!~');
          if (splitedDob[0] != '-') {
            this.displaydob = true;
            this.dob = splitedDob[0];
          } else if (splitedDob[0] === '-') {
            this.displaydob = false;
          }

          this.displaymarksheet = true;
          const splitedMarksheet = res.marksheet.split('~!~');
          if (splitedMarksheet[0] != '-') {
            this.displaymarksheet = true;
            this.marksheet = splitedMarksheet[0];
          } else if (splitedMarksheet[0] === '-') {
            this.displaymarksheet = false;
          }

          this.displaymigration = true;
          const splitedMigration = res.migration.split('~!~');
          if (splitedMigration[0] != '-') {
            this.displaymigration = true;
            this.migration = splitedMigration[0];
          } else if (splitedMigration[0] === '-') {
            this.displaymigration = false;
          }

          this.displaycaste = true;
          const splitedCaste = res.caste.split('~!~');
          if (splitedCaste[0] != '-') {
            this.displaycaste = true;
            this.caste = splitedCaste[0];
          } else if (splitedCaste[0] === '-') {
            this.displaycaste = false;
          }

          this.displayequivalence = true;
          const splitedEquivalence = res.equivalence.split('~!~');
          if (splitedEquivalence[0] != '-') {
            this.displayequivalence = true;
            this.equivalence = splitedEquivalence[0];
          } else if (splitedEquivalence[0] === '-') {
            this.displayequivalence = false;
          }

          this.displaydisability = true;
          const splitedDisability = res.disability.split('~!~');
          if (splitedDisability[0] != '-') {
            this.displaydisability = true;
            this.disability = splitedDisability[0];
          } else if (splitedDisability[0] === '-') {
            this.displaydisability = false;
          }

          this.displayphotoidfather = true;
          const splitedPhotoidfather = res.photoidfather.split('~!~');
          if (splitedPhotoidfather[0] != '-') {
            this.displayphotoidfather = true;
            this.photoidfather = splitedPhotoidfather[0];
          } else if (splitedPhotoidfather[0] === '-') {
            this.displayphotoidfather = false;
          }

          this.displayphotoidmother = true;
          const splitedPhotoidmother = res.photoidmother.split('~!~');
          if (splitedPhotoidmother[0] != '-') {
            this.displayphotoidmother = true;
            this.photoidmother = splitedPhotoidmother[0];
          } else if (splitedPhotoidmother[0] === '-') {
            this.displayphotoidmother = false;
          }

          this.displayphotoidstudent = true;
          const splitedPhotoidstudent = res.photoidstudent.split('~!~');
          if (splitedPhotoidstudent[0] != '-') {
            this.displayphotoidstudent = true;
            this.photoidstudent = splitedPhotoidstudent[0];
          } else if (splitedPhotoidstudent[0] === '-') {
            this.displayphotoidstudent = false;
          }

          // this.docchkbx1 = true; this.docchkbx2 = true; this.docchkbx3 = true; this.docchkbx4 = true;this.docchkbx5 = true;
          // this.displaydocupload = true;
          // this.disabledocchk= true;
          // this.allchecked = true;
        } else { // Else part if not Admin

          if (res.admitcard != '-') {
            this.displayadmitcard = true;
            this.admitcard = res.admitcard;
          }
          if (res.photo != '-') {
            this.showuploadedDocs = true;
            this.displayphoto = true;
            this.photo = res.photo;
          }
          if (res.sign != '-') {
            this.displaysign = true;
            this.sign = res.sign;

            // this.docchkbx1 = true; this.docchkbx2 = true; this.docchkbx3 = true; this.docchkbx4 = true;this.docchkbx5 = true;
            // this.displaydocupload = true;
            // this.disabledocchk= true;
            // this.allchecked = true;
          }
          if (res.dob != '-') {
            this.displaydob = true;
            this.dob = res.dob;
          }
          if (res.marksheet != '-') {
            this.displaymarksheet = true;
            this.marksheet = res.marksheet;
          }
          if (res.migration != '-') {
            this.displaymigration = true;
            this.migration = res.migration;
          }
          if (res.caste != '-') {
            this.displaycaste = true;
            this.caste = res.caste;
          }
          if (res.equivalence != '-') {
            this.displayequivalence = true;
            this.equivalence = res.equivalence;
          }
          if (res.disability != '-') {
            this.displaydisability = true;
            this.disability = res.disability;
          }

          if (res.photoidfather != '-') {
            this.displayphotoidfather = true;
            this.photoidfather = res.photoidfather;
          }
          if (res.photoidmother != '-') {
            this.displayphotoidmother = true;
            this.photoidmother = res.photoidmother;
          }
          if (res.photoidstudent != '-') {
            this.displayphotoidstudent = true;
            this.photoidstudent = res.photoidstudent;
          }
          // ========start add by a=========================
          //  const splitedadmtCard = res.admitcard.split('~!~');
          //   if (splitedadmtCard[1] === 'Approved') {
          //     this.displayadmitcard = false;
          //     this.admitcard = splitedadmtCard[0];
          //   }
          const splitedPhoto = res.photo.split('~!~');
          // console.log(splitedPhoto[1]);
          if (splitedPhoto[1] === 'Approved') {
            // this.showuploadedDocs = true;
            this.displayphoto = true;
            this.individualPhoto = true;
            this.photo = splitedPhoto[0];
          } else if (splitedPhoto[0] != '-') {
            this.displayphoto = true;
            this.photo = splitedPhoto[0];
          } else if (splitedPhoto[0] === '-') {
            this.displayphoto = false;
          }

          const splitedSign = res.sign.split('~!~');
          if (splitedSign[1] === 'Approved') {
            this.displaysign = true;
            this.sign = splitedSign[0];

            this.docchkbx1 = true; this.docchkbx2 = true; this.docchkbx3 = true; this.docchkbx4 = true; this.docchkbx5 = true;
            this.displaydocupload = true;
            this.disabledocchk = true;
            this.allchecked = true;
            this.individualSign = true;
          } else if (splitedSign[0] != '-') {
            this.displaysign = true;
            this.sign = splitedSign[0];
          } else if (splitedSign[0] === '-') {
            this.displaysign = false;
          }

          const splitedDob = res.dob.split('~!~');
          if (splitedDob[1] === 'Approved') {
            this.displaydob = true;
            this.individualDob = true;
            this.dob = splitedDob[0];
          } else if (splitedDob[0] != '-') {
            this.displaydob = true;
            this.dob = splitedDob[0];
          } else if (splitedDob[0] === '-') {
            this.displaydob = false;
          }

          const splitedMarksheet = res.marksheet.split('~!~');
          if (splitedMarksheet[1] === 'Approved') {
            this.displaymarksheet = true;
            this.individualMarksheet = true;
            this.marksheet = splitedMarksheet[0];
          } else if (splitedMarksheet[0] != '-') {
            this.displaymarksheet = true;
            this.marksheet = splitedMarksheet[0];
          } else if (splitedMarksheet[0] === '-') {
            this.displaymarksheet = false;
          }

          const splitedMigration = res.migration.split('~!~');
          if (splitedMigration[1] === 'Approved') {
            this.displaymigration = true;
            this.individualMigration = true;
            this.migration = splitedMigration[0];
          } else if (splitedMigration[0] != '-') {
            this.displaymigration = true;
            this.migration = splitedMigration[0];
          } else if (splitedMigration[0] === '-') {
            this.displaymigration = false;
          }

          const splitedCaste = res.caste.split('~!~');
          if (splitedCaste[1] === 'Approved') {
            this.displaycaste = true;
            this.individualCaste = true;
            this.caste = splitedCaste[0];
          } else if (splitedCaste[0] != '-') {
            this.displaycaste = true;
            this.caste = splitedCaste[0];
          } else if (splitedCaste[0] === '-') {
            this.displaycaste = false;
          }

          const splitedEquivalence = res.equivalence.split('~!~');
          if (splitedEquivalence[1] === 'Approved') {
            this.displayequivalence = true;
            this.individualEquivalence = true;
            this.equivalence = splitedEquivalence[0];
          } else if (splitedEquivalence[0] != '-') {
            this.displayequivalence = true;
            this.equivalence = splitedEquivalence[0];
          } else if (splitedEquivalence[0] === '-') {
            this.displayequivalence = false;
          }

          const splitedDisability = res.disability.split('~!~');
          if (splitedDisability[1] === 'Approved') {
            this.displaydisability = true;
            this.individualDisability = true;
            this.disability = splitedDisability[0];
          } else if (splitedDisability[0] != '-') {
            this.displaydisability = true;
            this.disability = splitedDisability[0];
          } else if (splitedDisability[0] === '-') {
            this.displaydisability = false;
          }

          const splitedPhotoidfather = res.photoidfather.split('~!~');
          if (splitedPhotoidfather[1] === 'Approved') {
            this.displayphotoidfather = true;
            this.individualPhotoidfather = true;
            this.photoidfather = splitedPhotoidfather[0];
          } else if (splitedPhotoidfather[0] != '-') {
            this.displayphotoidfather = true;
            this.photoidfather = splitedPhotoidfather[0];
          } else if (splitedPhotoidfather[0] === '-') {
            this.displayphotoidfather = false;
          }

          const splitedPhotoidmother = res.photoidmother.split('~!~');
          if (splitedPhotoidmother[1] === 'Approved') {
            this.displayphotoidmother = true;
            this.individualPhotoidmother = true;
            this.photoidmother = splitedPhotoidmother[0];
          } else if (splitedPhotoidmother[0] != '-') {
            this.displayphotoidmother = true;
            this.photoidmother = splitedPhotoidmother[0];
          } else if (splitedPhotoidmother[0] === '-') {
            this.displayphotoidmother = false;
          }

          const splitedPhotoidstudent = res.photoidstudent.split('~!~');
          if (splitedPhotoidstudent[1] === 'Approved') {
            this.displayphotoidstudent = true;
            this.individualPhotoidstudent = true;
            this.photoidstudent = splitedPhotoidstudent[0];
          } else if (splitedPhotoidstudent[0] != '-') {
            this.displayphotoidstudent = true;
            this.photoidstudent = splitedPhotoidstudent[0];
          } else if (splitedPhotoidstudent[0] === '-') {
            this.displayphotoidstudent = false;
          }
        }
        // ==========end add by a=========================
      } else {
        this.showuploadedDocs = false;
        this.displaydocupload = false;
      }
    }, error => {
      this.spinner.hide();
      alert('Something weent wrong.Please try again');
    })
  }

  onFloatClick() {
    window.open("https://app.botbaba.io/bot/1158ALGR6Xj/BESC%20QBOT");
  }

  getFianancialAid(coursedetailsid, courseid, freeshipapplied) {
    this.submitDisable = false; // sumit button step 4 related

    this.displayfatherdetailsForm = false;
    this.chkbx1 = false; this.chkbx2 = false; this.chkbx3 = false;
    this.displaygujratiadmForm = false;
    this.coursedetailid = coursedetailsid;
    this.hidegreenredbtn = false;
    this.showgujaratiadmtype = false;
    this.courseid = courseid;
    if (courseid == 65) {
      this.showdaylist = true;
    } else {
      this.showdaylist = false;
    }
    this.displaygujratiadm = true;
    this.gujratiadmForm = this.fb.group({
      gujaratiperiod: [null, Validators.required],
      freeshipfathermobno: [''],
      freeshipfatheroccupation: [''],
      freeshipemployer: [''],
      freeshipprevinstfees: [''],
      // gujaratiadmtype: ['', Validators.required],
      pid: [this.token.id],
      courseid: [courseid],
      coursedetailid: [coursedetailsid]
    });
    this.spinner.show();
    this.registrationService.getfiancialdetails(this.token.authToken, coursedetailsid).then(res => {

      this.financialdata = res.data;
      // console.log(this.financialdata);
      this.spinner.hide();
      if (res.data.gujaratiperiod != null) {
        this.disablegujform = true;
        this.gujratiadmForm.get('gujaratiperiod').disable();
        this.gujratiadmForm.get('freeshipfathermobno').disable();
        this.gujratiadmForm.get('freeshipfatheroccupation').disable();
        this.gujratiadmForm.get('freeshipemployer').disable();
        this.gujratiadmForm.get('freeshipprevinstfees').disable();
        // this.gujratiadmForm.get('gujaratiadmtype').disable();
      }
      else {
        this.disablegujform = false;
        this.gujratiadmForm.get('gujaratiperiod').enable();
        this.gujratiadmForm.get('freeshipfathermobno').enable();
        this.gujratiadmForm.get('freeshipfatheroccupation').enable();
        this.gujratiadmForm.get('freeshipemployer').enable();
        this.gujratiadmForm.get('freeshipprevinstfees').enable();
        // this.gujratiadmForm.get('gujaratiadmtype').enable();
      }
      if (freeshipapplied == 1) {
        this.gujratiadmForm.reset();
        this.chkbx1 = true; this.chkbx2 = true; this.chkbx3 = true;
        this.displaygujratiadmForm = true;
        this.showgujaratiadmtype = true;
        if (res.data.freeshipfatheroccupation != null) {
          this.displayfatherdetailsForm = true;
        }
        else {
          this.displayfatherdetailsForm = false;
        }
        this.gujratiadmForm.patchValue(res.data);
        this.changeday();
      }
      else {
        if (res.data.gujaratiperiod != null) {
          this.chkbx1 = true; this.chkbx2 = true; this.chkbx3 = true;
          this.displaygujratiadmForm = true;
          this.displayfatherdetailsForm = false;
          this.showgujaratiadmtype = true;
          this.gujratiadmForm.patchValue(res.data);
          this.changeday();
          // if(courseid==49 || courseid == 52){
          //   this.hidegreenredbtn = false;
          // }else{
          //   this.hidegreenredbtn = true;
          // }
        }
      }
    }, error => {
      this.spinner.hide();
    })
  }
  changeStatus1(e) {
    if (this.chkbx1 && this.chkbx2 && this.chkbx3) {
      this.displaygujratiadmForm = true;
    }
    else {
      this.displaygujratiadmForm = false;
    }
  }
  changeStatus2(e) {
    if (this.chkbx1 && this.chkbx2 && this.chkbx3) {
      this.displaygujratiadmForm = true;
    }
    else {
      this.displaygujratiadmForm = false;
    }
  }
  changeStatus3(e) {
    if (this.chkbx1 && this.chkbx2 && this.chkbx3) {
      this.displaygujratiadmForm = true;
    }
    else {
      this.displaygujratiadmForm = false;
    }
  }

  needAssistance() {
    this.spinner.show();

    // ===================== add by a====
    this.registrationService.sendfthmthmobocpdtlsfaidgjrt(this.token.authToken).then(data => {
      this.spinner.hide();
      // console.log(data);
      // this.displayfatherdetailsForm = true;

      if (data.status === "success") {
        // console.log(data);
        if (data.type === 'f') {
          this.requiredFlag = true;
          this.step3LabelName = 'Father';

          this.gujratiadmForm.get('gujaratiperiod').enable();
          this.gujratiadmForm.get('freeshipfatheroccupation').enable();
          this.gujratiadmForm.get('freeshipfathermobno').enable();
          this.gujratiadmForm.get('freeshipemployer').enable();
          this.gujratiadmForm.get('freeshipprevinstfees').enable();

          const gujaratiperiod = this.gujratiadmForm.get('gujaratiperiod');
          const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
          const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
          const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');
          const freeshipprevinstfees = this.gujratiadmForm.get('freeshipprevinstfees');

          gujaratiperiod.setValidators([Validators.required]);
          freeshipfathermobno.setValidators([Validators.required, Validators.minLength(10), Validators.pattern(this.mobRegEx)]);
          freeshipfatheroccupation.setValidators([Validators.required]);
          freeshipemployer.setValidators([Validators.required]);
          freeshipprevinstfees.setValidators([Validators.required]);

          gujaratiperiod.updateValueAndValidity();
          freeshipfathermobno.updateValueAndValidity();
          freeshipfatheroccupation.updateValueAndValidity();
          freeshipemployer.updateValueAndValidity();
          freeshipprevinstfees.updateValueAndValidity();

          // this.gujratiadmForm.get('freeshipfatheroccupation').disable();
          // this.gujratiadmForm.get('freeshipfathermobno').disable();

          // const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
          // const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
          // freeshipfathermobno.clearValidators();
          // freeshipfatheroccupation.clearValidators();
          // freeshipfathermobno.updateValueAndValidity();
          // freeshipfatheroccupation.updateValueAndValidity();

          // this.gujratiadmForm.patchValue({        // Patch value for mobile no and occupation
          //   freeshipfatheroccupation: data.occname,
          //   freeshipfathermobno: data.mobno,
          // })

        } else if (data.type === 'm') {
          this.requiredFlag = true;
          this.step3LabelName = 'Mother';

          this.gujratiadmForm.get('gujaratiperiod').enable();
          this.gujratiadmForm.get('freeshipfatheroccupation').enable();
          this.gujratiadmForm.get('freeshipfathermobno').enable();
          this.gujratiadmForm.get('freeshipemployer').enable();
          this.gujratiadmForm.get('freeshipprevinstfees').enable();

          const gujaratiperiod = this.gujratiadmForm.get('gujaratiperiod');
          const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
          const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
          const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');
          const freeshipprevinstfees = this.gujratiadmForm.get('freeshipprevinstfees');

          gujaratiperiod.setValidators([Validators.required]);
          freeshipfathermobno.setValidators([Validators.required, Validators.minLength(10), Validators.pattern(this.mobRegEx)]);
          freeshipfatheroccupation.setValidators([Validators.required]);
          freeshipemployer.setValidators([Validators.required]);
          freeshipprevinstfees.setValidators([Validators.required]);

          gujaratiperiod.updateValueAndValidity();
          freeshipfathermobno.updateValueAndValidity();
          freeshipfatheroccupation.updateValueAndValidity();
          freeshipemployer.updateValueAndValidity();
          freeshipprevinstfees.updateValueAndValidity();

          // this.gujratiadmForm.get('freeshipfatheroccupation').disable();
          // this.gujratiadmForm.get('freeshipfathermobno').disable();

          // const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
          // const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
          // freeshipfathermobno.clearValidators();
          // freeshipfatheroccupation.clearValidators();
          // freeshipfathermobno.updateValueAndValidity();
          // freeshipfatheroccupation.updateValueAndValidity();

          // this.gujratiadmForm.patchValue({        // Patch value for mobile no and occupation
          //   freeshipfatheroccupation: data.occname,
          //   freeshipfathermobno: data.mobno,
          // })

        } else {
          this.requiredFlag = false;

          this.step3LabelName = 'Father';

          this.gujratiadmForm.get('freeshipfatheroccupation').disable();
          this.gujratiadmForm.get('freeshipfathermobno').disable();
          this.gujratiadmForm.get('freeshipemployer').disable();

          // this.gujratiadmForm.get('freeshipfatheroccupation').enable();
          // this.gujratiadmForm.get('freeshipfathermobno').enable();

          const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
          const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
          const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');

          freeshipfathermobno.clearValidators();
          freeshipfatheroccupation.clearValidators();
          freeshipemployer.clearValidators();

          // freeshipfathermobno.setValue(null);
          // freeshipfatheroccupation.setValue(null);

          // freeshipfathermobno.setValidators([Validators.required, Validators.minLength(10), Validators.pattern(this.mobRegEx)]);
          // freeshipfatheroccupation.setValidators([Validators.required]);

          freeshipfathermobno.updateValueAndValidity();
          freeshipfatheroccupation.updateValueAndValidity();
          freeshipemployer.updateValueAndValidity();

          // this.gujratiadmForm.patchValue({        // Patch value for mobile no and occupation
          //   freeshipfatheroccupation: null,
          //   freeshipfathermobno: null,
          // })

        }

      } else {
        this.requiredFlag = false;

        this.step3LabelName = 'Father';

        this.gujratiadmForm.get('freeshipfatheroccupation').disable();
        this.gujratiadmForm.get('freeshipfathermobno').disable();
        this.gujratiadmForm.get('freeshipemployer').disable();

        const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
        const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
        const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');

        freeshipfathermobno.clearValidators();
        freeshipfatheroccupation.clearValidators();
        freeshipemployer.clearValidators();

        freeshipfathermobno.updateValueAndValidity();
        freeshipfatheroccupation.updateValueAndValidity();
        freeshipemployer.updateValueAndValidity();


        // this.gujratiadmForm.get('freeshipfatheroccupation').enable();
        // this.gujratiadmForm.get('freeshipfathermobno').enable();

        // const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
        // const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
        // freeshipfathermobno.setValidators([Validators.required, Validators.minLength(10),Validators.pattern(this.mobRegEx)]);
        // freeshipfatheroccupation.setValidators([Validators.required]);
        // freeshipfathermobno.updateValueAndValidity();
        // freeshipfatheroccupation.updateValueAndValidity();

        // this.gujratiadmForm.patchValue({        // Patch value for mobile no and occupation
        //   freeshipfatheroccupation: null,
        //   freeshipfathermobno: null,
        // })

      }
    });

    // ===================== add end by a====

    if (this.courseid == 49 || this.courseid == 52) {
      alert('No financial aid is granted for self-financed courses.');
      // this.showgujaratiadmtype = true;
      // this.disablegujform = true; //button
      this.displayfatherdetailsForm = false;  //father details portion
      this.requiredFlag = false; // red required signal

      this.redButtonDisable = true;
      this.greenButtonDisable = false;

      this.submitDisable = false; // sumit button step 4 related
    }
    else {
      this.redButtonDisable = true;
      this.greenButtonDisable = true;

      this.submitDisable = true; // sumit button step 4 related

      this.requiredFlag = true; // red required signal
      this.disablegujform = false;
      this.showgujaratiadmtype = true;
      this.displayfatherdetailsForm = true;
      const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
      const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');
      const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
      const freeshipprevinstfees = this.gujratiadmForm.get('freeshipprevinstfees');
      freeshipfathermobno.setValidators([Validators.required, Validators.minLength(10), Validators.pattern(this.mobRegEx)]);
      freeshipemployer.setValidators([Validators.required]);
      freeshipfatheroccupation.setValidators([Validators.required]);
      freeshipprevinstfees.setValidators([Validators.required]);
      freeshipfathermobno.updateValueAndValidity();
      freeshipemployer.updateValueAndValidity();
      freeshipfatheroccupation.updateValueAndValidity();
      freeshipprevinstfees.updateValueAndValidity();
      if (this.financialdata.freeshipemployer != null) {
        this.gujratiadmForm.get('freeshipfathermobno').setValue(this.financialdata.freeshipfathermobno);
        this.gujratiadmForm.get('freeshipemployer').setValue(this.financialdata.freeshipemployer);
        this.gujratiadmForm.get('freeshipfatheroccupation').setValue(this.financialdata.freeshipfatheroccupation);
        this.gujratiadmForm.get('freeshipprevinstfees').setValue(this.financialdata.freeshipprevinstfees);
      }
    }

  }

  needNotAssistance() {
    if (this.courseid == 49 || this.courseid == 52) {
      // alert('No financial aid is granted for self-financed courses.');
      this.showgujaratiadmtype = true;

      this.submitDisable = true; // sumit button step 4 related

      // -------------------Add by JD ----------------
      // this.gujratiadmForm.get('gujaratiperiod').enable();
      // const gujaratiperiod = this.gujratiadmForm.get('gujaratiperiod');
      // gujaratiperiod.setValidators([Validators.required]);
      // gujaratiperiod.updateValueAndValidity();
      // ---------------------end by JD ---------------

      const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
      const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');
      const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
      const freeshipprevinstfees = this.gujratiadmForm.get('freeshipprevinstfees');
      freeshipfathermobno.clearValidators();
      freeshipemployer.clearValidators();
      freeshipfatheroccupation.clearValidators();
      freeshipprevinstfees.clearValidators();

      freeshipfathermobno.updateValueAndValidity();
      freeshipemployer.updateValueAndValidity();
      freeshipfatheroccupation.updateValueAndValidity();
      freeshipprevinstfees.updateValueAndValidity();

      this.gujratiadmForm.get('freeshipfathermobno').setValue('');
      this.gujratiadmForm.get('freeshipemployer').setValue('');
      this.gujratiadmForm.get('freeshipfatheroccupation').setValue('');
      this.gujratiadmForm.get('freeshipprevinstfees').setValue('');
    }
    else {
      this.submitDisable = true; // sumit button step 4 related

      this.showgujaratiadmtype = true;

      // ----------------------------add by JD ----------------
      // this.gujratiadmForm.get('gujaratiperiod').enable();
      // const gujaratiperiod = this.gujratiadmForm.get('gujaratiperiod');
      // gujaratiperiod.setValidators([Validators.required]);
      // gujaratiperiod.updateValueAndValidity();
      // --------------------------------end by JD ------------

      const freeshipfathermobno = this.gujratiadmForm.get('freeshipfathermobno');
      const freeshipemployer = this.gujratiadmForm.get('freeshipemployer');
      const freeshipfatheroccupation = this.gujratiadmForm.get('freeshipfatheroccupation');
      const freeshipprevinstfees = this.gujratiadmForm.get('freeshipprevinstfees');
      freeshipfathermobno.clearValidators();
      freeshipemployer.clearValidators();
      freeshipfatheroccupation.clearValidators();
      freeshipprevinstfees.clearValidators();

      freeshipfathermobno.updateValueAndValidity();
      freeshipemployer.updateValueAndValidity();
      freeshipfatheroccupation.updateValueAndValidity();
      freeshipprevinstfees.updateValueAndValidity();
      this.gujratiadmForm.get('freeshipfathermobno').setValue('');
      this.gujratiadmForm.get('freeshipemployer').setValue('');
      this.gujratiadmForm.get('freeshipfatheroccupation').setValue('');
      this.gujratiadmForm.get('freeshipprevinstfees').setValue('');
      this.displayfatherdetailsForm = false;
    }
  }

  submitFinancialAid() {
    if (this.gujratiadmForm.value.gujaratiperiod == 'null') {
      alert('Please select day');
      return false;
    }
    else {
      // console.log(this.gujratiadmForm.value);
      if (this.gujratiadmForm.valid) {
        this.displaygujratiadm = false;
        this.displayGujAdmDialog = true;
        if (this.showdaylist) {
          for (let i = 0; i < this.dayListBcom.length; i++) {
            if (this.dayListBcom[i].id == this.gujratiadmForm.get('gujaratiperiod').value) {
              this.dayname = this.dayListBcom[i].name;
              break;
            }
          }
        }
        else {
          for (let i = 0; i < this.dayList.length; i++) {
            if (this.dayList[i].id == this.gujratiadmForm.get('gujaratiperiod').value) {
              this.dayname = this.dayList[i].name;
              break;
            }
          }
        }
        // if(this.gujratiadmForm.value.gujaratiadmtype =='virtual'){
        //   this.gujadmtype = 'I prefer virtual Gujarati Admission Interview';
        // }
        // else{
        //   this.gujadmtype = 'I prefer physical meeting at College premise';
        // }
      }
      else {
        Object.keys(this.gujratiadmForm.controls).forEach(control => {
          this.gujratiadmForm.controls[control].markAsDirty();
        });
      }
    }
  }

  changeday() {
    //alert(this.gujratiadmForm.value.gujaratiperiod);
    if (this.gujratiadmForm.value.gujaratiperiod != 'null') {
      this.hidegreenredbtn = true;

      this.redButtonDisable = true;
      this.greenButtonDisable = true;

      // console.log(this.financialdata);
      // if (this.courseid == 49 || this.courseid == 52) {        //append by a
      //   this.redButtonDisable = true;
      //   this.greenButtonDisable = false;
      // }else{
      //   this.redButtonDisable = true;
      //   this.greenButtonDisable = true;
      // }


      if (this.financialdata.gujaratiperiod != null && this.courseid != 49 && this.courseid != 52) {

        if (this.financialdata.freeshipappdate != null) {

          this.displayfatherdetailsForm = true;
        } else {

          this.displayfatherdetailsForm = false;
        }
      }
      // if (this.financialdata.gujaratiadmtype != null) {
      //   this.showgujaratiadmtype = true;
      // }
    }
    else {
      this.hidegreenredbtn = false;
      this.displayfatherdetailsForm = false;
    }
  }

  acceptAdm = function () {
    if (confirm('Are you sure you want to proceed?')) {
      let data = this.gujratiadmForm.value;
      data.courseid = this.courseid;
      data.coursedetailid = this.coursedetailid;
      data.pid = this.token.id;
      this.spinner.show();
      this.registrationService.submitfinancialaid(data, this.token.authToken).subscribe(data => {
        this.dataList = data;
        if (this.dataList.status === 'success') {
          if (this.dataList.pdf === '-') {
            alert("Your application for admission under Gujarati Quota is registered successfully. You will be notified about your schedule by SMS/Email.");
            // window.open(this.dataList.pdf);
            this.displaygujratiadm = false;
            this.displayGujAdmDialog = false;
            this.gujratiadmForm.reset();
            this.displayfatherdetailsForm = false;
            this.chkbx1 = false; this.chkbx2 = false; this.chkbx3 = false;
            this.admstatus();
            this.spinner.hide();
          } else {
            alert("Your application for admission under Gujarati Quota is registered successfully. You will be notified about your schedule by SMS/Email.");
            window.open(this.dataList.pdf);
            this.displaygujratiadm = false;
            this.displayGujAdmDialog = false;
            this.gujratiadmForm.reset();
            this.displayfatherdetailsForm = false;
            this.chkbx1 = false; this.chkbx2 = false; this.chkbx3 = false;
            this.admstatus();
            this.spinner.hide();
          }
        }
      }, error => {
        this.spinner.hide();
        alert('Somethng went wrong. Please try again.')
      });
    }
  }
  rejectAdm = function () {
    this.displayGujAdmDialog = false;
    this.displaygujratiadm = true;
  };

  showPhotoInstruction() {
    if (this.disblephotouploadbtn) {
      this.displayPhotoInstruction = true;
      this.pdfSrc = "https://www.thebges.edu.in/wp-content/uploads/2020/08/Photo-Upload-Instructions-20-21.pdf";
    }
    else {
      alert('Photo upload option will be enabled for applicants who are merited and have paid admission fees.');
    }

  }

  showUploadPhoto() {
    this.displayPhotoInstruction = false;
    this.displayUploadPhoto = true;
    this.msgPhotoUpload = [];
    this.msgPhotoUpload.push({ severity: 'info', summary: 'Please Note :' });
    this.msgPhotoUpload.push({
      severity: 'info',
      detail:
        '1. Max Size Limit: 150 KB. (Height = 230 pixel * Width = 175 pixel)'
    });
    this.msgPhotoUpload.push({
      severity: 'info',
      detail:
        '2. Supported Formats : JPEG,JPG'
    });
    this.msgPhotoUpload.push({
      severity: 'info',
      detail:
        '3. For more details read<a href="https://www.thebges.edu.in/wp-content/uploads/2020/08/Photo-Upload-Instructions-21.pdf" target="_blank"> Instructions for uploading photograph</a>'
    });
    this.msgPhotoUpload.push({
      severity: 'info',
      detail:
        '4. If you want to resize your photo, you may do so by following the process mentioned below - <br>&nbsp;&nbsp;&nbsp; i. Click on <a href="https://www.img2go.com/resize-image" target="_blank">img2go</a> to visit the website.<br> &nbsp;&nbsp;&nbsp; ii. Click on "Choose File" and select the photo you want to resize for uploading. <br> &nbsp;&nbsp;&nbsp; iii. Under "Settings", select JPG in Target format and mention the width and height as mentioned in note no 1 above <small>You may skip giving the DPI</small>. <br>&nbsp;&nbsp;&nbsp; iv. Click on "Start" button to process your photograph. <br>&nbsp;&nbsp;&nbsp; v. Once done, you need to download your photograph and upload it by clicking on "Choose" button below.'

    });
    this.showDocuments();
  }

  rejectphotoinstruction() {
    this.displayPhotoInstruction = false;
  }

  sendphotouploadsms() {
    this.spinner.show();
    this.registrationService.sendphotosms(this.token.authToken).then(res => {
      this.spinner.hide();
      alert('Photo Uploaded successfully');
    }, error => {
      this.spinner.hide();
    })
  }

  addSports() {
    const control = <FormArray>this.sportsquotaForm.controls['sportsDetails'];
    const newMarksGroup: FormGroup = this.initItemssports();
    control.push(newMarksGroup);
  }
  initItemssports(): FormGroup {
    return this.fb.group({
      sportsid: [],
      levelid: [],
      id: [''],
      filename: [''],
      parent_id: [],
      levelother: [],
      certificateyear: [null]
    });
  }

  // getsportsquota(coursedetailid) {
  //   this.chkbx4 = false; this.chkbx5 = false; this.chkbx6 = false;
  //   this.displaysportsquotaadm = true;
  //   this.sportscoursedetailid = coursedetailid;
  //   this.registrationService.getAdditionalList(this.token.authToken).subscribe(data => {
  //     this.dataListnew = data;
  //     this.admsportsList = this.dataListnew.admsportsList;
  //     this.awardlevelList = this.dataListnew.awardlevelList;
  //   })
  //   this.sportsquotaForm = this.fb.group({
  //     sportsadmtype: ['', Validators.required],
  //     sportsDetails: this.fb.array([])
  //   });
  //   this.spinner.show();
  //   this.registrationService.getsportsdetails(this.token.authToken, coursedetailid).then(res => {
  //     // console.log(res);
  //     this.spinner.hide();
  //     this.sportsdetailTable = res.data.sportsDetails;
  //     this.filepath = res.path;
  //     if (res.sportsquotaadmtype != '') {
  //       this.sportsquotaForm.controls.sportsadmtype.setValue(res.sportsquotaadmtype);
  //       this.chkbx4 = true; this.chkbx5 = true; this.chkbx6 = true;
  //       this.setSports();
  //       this.displaysportsquotaForm = true;
  //       this.showsportstype = true;
  //       this.disabesportsform = true;
  //       this.sportsquotaForm.get('sportsadmtype').disable();
  //       const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
  //       for (let i = 0; i < controlArray.length; i++) {
  //         controlArray.controls[i].get('levelother').disable();
  //         controlArray.controls[i].get('certificateyear').disable();
  //       }
  //     } else {
  //       this.chkbx4 = false; this.chkbx5 = false; this.chkbx6 = false;
  //       this.displaysportsquotaForm = false;
  //       this.showsportstype = false;
  //       this.sportsquotaForm.controls.sportsadmtype.setValue('');
  //       this.disabesportsform = false;

  //     }

  //   }, err => {
  //     this.spinner.hide();
  //   })

  // }

  getsportsquota(coursedetailid) {      // by JD
    // console.log(coursedetailid);
    this.chkbx4 = false;
    this.disabesportsform = true;
    this.displaysportsquotaadm = true;
    this.sportscoursedetailid = coursedetailid;
  }

  changeStatus4(e) {
    if (e) {                                             // by JD
      this.disabesportsform = false;
    } else {
      this.disabesportsform = true;
    }

    // if (this.chkbx4 && this.chkbx5 && this.chkbx6) {
    //   this.displaysportsquotaForm = true;
    //   this.setSports();
    // }
    // else {
    //   this.displaysportsquotaForm = false;
    // }
  }

  // changeStatus5(e) {
  //   if (this.chkbx4 && this.chkbx5 && this.chkbx6) {
  //     this.displaysportsquotaForm = true;
  //     this.setSports();
  //   }
  //   else {
  //     this.displaysportsquotaForm = false;
  //   }
  // }
  // changeStatus6(e) {
  //   if (this.chkbx4 && this.chkbx5 && this.chkbx6) {
  //     this.displaysportsquotaForm = true;
  //     this.setSports();
  //   }
  //   else {
  //     this.displaysportsquotaForm = false;
  //   }
  // }

  setSports() {
    const control = <FormArray>this.sportsquotaForm.controls.sportsDetails;
    const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
    this.sportsdetailTable.forEach((x, i) => {
      control.push(
        this.fb.group({
          sportsid: x.sportsid,
          levelid: x.levelid,
          id: x.id,
          parent_id: x.parent_id,
          filename: x.filename,
          levelother: x.levelother,
          certificateyear: x.certificateyear
        })
      );
      controlArray.controls[i].get('sportsid').disable();
      controlArray.controls[i].get('levelid').disable();
    });
  }

  submitSportsDetails() {
    // this.displaysportsquotaadm = false;
    if (this.sportsquotaForm.valid) {
      this.displaySportsAdmDialog = true;
      this.displaysportsquotaadm = false;
      const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
      for (let i = 0; i < controlArray.length; i++) {
        controlArray.controls[i].get('sportsid').enable();
        controlArray.controls[i].get('levelid').enable();
      }
      this.displaysportslist = this.sportsquotaForm.value.sportsDetails;
      if (this.sportsquotaForm.value.sportsadmtype == 'virtual') {
        this.sportsadmtype = 'I prefer virtual meeting with the Sports Committee of the College';
      }
      else {
        this.sportsadmtype = 'I prefer physical meeting with the Sports Committee at College premise';
      }

      // console.log(this.displaysportslist);
    }
    else {
      Object.keys(this.sportsquotaForm.controls).forEach(control => {
        this.sportsquotaForm.controls[control].markAsDirty();
      });
    }
  }

  donesportsdetails() {
    // this.displaysportsquotaadm = false;
    const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
    for (let i = 0; i < controlArray.length; i++) {
      controlArray.controls[i].get('levelid').enable();
    }
    let obj = this.sportsquotaForm.value.sportsDetails;
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].levelid == 4) {
        if (obj[i].levelother == null) {
          alert('Please mention Other level at row no.' + (1 + i) + '');
          for (let i = 0; i < controlArray.length; i++) {
            controlArray.controls[i].get('levelid').disable();
          }
          return false;
        }
      }
      if (obj[i].certificateyear == null) {
        alert('Please select Year of Certificate at row no.' + (1 + i) + '');
        for (let i = 0; i < controlArray.length; i++) {
          controlArray.controls[i].get('levelid').disable();
        }
        return false;
      }
      if (obj[i].filename == null) {
        alert('Please Upload Certificate at row no.' + (1 + i) + '');
        for (let i = 0; i < controlArray.length; i++) {
          controlArray.controls[i].get('levelid').disable();
        }
        return false;
      }
    }
    for (let i = 0; i < controlArray.length; i++) {
      controlArray.controls[i].get('levelid').disable();
    }
    this.showsportstype = true;
  }

  getsportsname(index) {
    const control = this.displaysportslist;
    let obj = this.admsportsList.find(o => o.id === control[index].sportsid);
    return obj.name;
  }

  getlevelname(index) {
    const control = this.displaysportslist;
    let obj = this.awardlevelList.find(o => o.id === control[index].levelid);
    return obj.name;
  }

  rejectsportsAdm() {
    this.displaySportsAdmDialog = false;
    this.displaysportsquotaadm = true;
    const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
    for (let i = 0; i < controlArray.length; i++) {
      controlArray.controls[i].get('sportsid').disable();
      controlArray.controls[i].get('levelid').disable();
    }
  }

  acceptsportsAdm() {
    // this.displaySportsAdmDialog = false;
    // this.displaysportsquotaadm = false;
    // let sportsquotaadmtype  = this.sportsquotaForm.value.sportsadmtype;
    // const controlArray = <FormArray>this.sportsquotaForm.get('sportsDetails');
    // for(let i =0;i<controlArray.length;i++){
    //   controlArray.controls[i].get('sportsid').enable();
    //   controlArray.controls[i].get('levelid').enable();
    // }
    // let data = this.sportsquotaForm.value;
    // console.log(this.token.authToken);
    // console.log(this.sportscoursedetailid);
    this.spinner.show();
    //data,sportsquotaadmtype,
    this.registrationService.submitsportsform(this.token.authToken, this.sportscoursedetailid)
      .then(res => {
        // console.log(res);
        this.spinner.hide();
        if (res.status == 'success') {
          localStorage.setItem('sports', 'com');
          this.displaysportsquotaadm = false;
          this.displaySportsAdmDialog = false;
          alert("Your application for admission under Sports Quota is registered successfully. You will be notified about your schedule by SMS/Email.");
          this.admstatus();
        }

      }, err => {
        this.spinner.hide();
      })
  }

  showsportsdoc(url) {
    window.open(url);
  }

  showtblesportsdoc(url) {
    window.open(url);
  }

  viewSportsQuota(coursedetailsid, courseid) {
    this.spinner.show();
    this.registrationService.getsportsquotaform(localStorage.getItem('authToken'), this.token.id, coursedetailsid, courseid)
      .then(res => {
        this.spinner.hide();
        if (res.status === 'success') {
          window.open(res.pdfLink, "_blank");
        }
      }, error => {
        this.spinner.hide();
        alert('Something went wrong.Please try again.');
      });
  }

  changeStatusdoc1(e) {
    if (this.docchkbx1 && this.docchkbx2 && this.docchkbx3 && this.docchkbx4 && this.docchkbx5) {
      this.displaydocupload = true;
      this.allchecked = true;
    }
    else {
      this.displaydocupload = false;
      this.allchecked = false;
    }
  }
  changeStatusdoc2(e) {
    if (this.docchkbx1 && this.docchkbx2 && this.docchkbx3 && this.docchkbx4 && this.docchkbx5) {
      this.displaydocupload = true;
      this.allchecked = true;
    }
    else {
      this.displaydocupload = false;
      this.allchecked = false;
    }
  }
  changeStatusdoc3(e) {
    if (this.docchkbx1 && this.docchkbx2 && this.docchkbx3 && this.docchkbx4 && this.docchkbx5) {
      this.displaydocupload = true;
      this.allchecked = true;
    }
    else {
      this.displaydocupload = false;
      this.allchecked = false;
    }
  }

  changeStatusdoc4(e) {
    if (this.docchkbx1 && this.docchkbx2 && this.docchkbx3 && this.docchkbx4 && this.docchkbx5) {
      this.displaydocupload = true;
      this.allchecked = true;
    }
    else {
      this.displaydocupload = false;
      this.allchecked = false;
    }
  }
  changeStatusdoc5(e) {
    if (this.docchkbx1 && this.docchkbx2 && this.docchkbx3 && this.docchkbx4 && this.docchkbx5) {
      this.displaydocupload = true;
      this.allchecked = true;
    }
    else {
      this.displaydocupload = false;
      this.allchecked = false;
    }
  }

  cancel() {
    this.admstatus();
  }

  passChng() {
    this.router.navigate(['candidate/changepass']);
  }

  exInterestDialogbox(courseid, coursedetailid) {                  // Create by a
    this.spinner.show();
    this.uncheck = false;
    this.eoiDialogSubmit = false;
    this.courseid = courseid;
    this.coursedetailid = coursedetailid;
    // console.log(this.token.authToken,this.courseid, this.coursedetailid);
    localStorage.setItem('eoiCourseid', JSON.stringify(this.courseid));
    localStorage.setItem('eoiCourseDetailsid', JSON.stringify(this.coursedetailid));

    this.registrationService.sendeoistatuscoursewisevalidation(this.token.authToken, this.courseid, this.coursedetailid)
      .then(data => {
        this.spinner.hide();
        // console.log(data);
        if (data.status === "success" && data.eoicrsstatus === "present") {
          this.exInterestDisplay = true;
          this.courseName = data.coursename;
          this.courseSession = data.sessname;
          this.courseAppNo = data.appno;

          if (data.chkeoi == 'no') {
            this.eoiChkboxOption = true;
            this.eoiButtonName = "Register Expression of Interest";
          }
          if (data.chkeoi == 'yes') {
            this.eoiChkboxOption = false;
            this.eoiButtonName = "Withdraw Expression of Interest";
          }
        } else {
          alert('Date and Time over for the ' + data.coursename + ' Course !');
        }

      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });

  } // end exInterestDialogbox function

  toggleVisibility(val: boolean) {      // create by a
    if (val) {
      this.eoiDialogSubmit = true;
    } else {
      this.eoiDialogSubmit = false;
    }
  } // End toggleVisibility

  eoiUpdateInterest() {  // create by a
    this.spinner.show();
    this.courseid = JSON.parse(localStorage.getItem('eoiCourseid'));
    this.coursedetailid = JSON.parse(localStorage.getItem('eoiCourseDetailsid'));
    // console.log('courseid-'+this.courseid, 'courseDid-' + this.coursedetailid);
    this.chkeoi = 1;

    if (this.eoiChkboxOption === false) {
      this.chkeoi = 0;
    }

    this.registrationService.updateeoistatuscoursewise(this.token.authToken, this.courseid, this.chkeoi, this.coursedetailid)
      .then(data => {
        this.spinner.hide();
        // console.log(data);
        if (data.status === "success") {
          if (data.chkeoi === 'no') {
            this.eoiChkboxOption = true;
            this.eoiButtonName = "Register Expression of Interest";
          }
          if (data.chkeoi === 'yes') {
            this.eoiChkboxOption = false;
            this.eoiButtonName = "Withdraw Expression of Interest";
          }

          if (data.maxcountreached) {
            alert(data.maxcountreached);
            this.exInterestDisplay = false;
          } else if (data.flag === "w") {
            alert("Expression of Interest Successfully Removed by You");
            this.exInterestDisplay = false;
            this.admstatus();
          } else {
            alert("Expression of Interest Successfully Registered");
            this.exInterestDisplay = false;
            this.admstatus();
          }
        } // success End

      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });

  } // end eoiUpdateInterest


  enableVaccineName() {                              //add by a
    const vaccinename = this.familyinfoForm.get('vaccinename');
    if (this.familyinfoForm.value.vaccinated === 'No' || this.familyinfoForm.value.vaccinated === null) {
      this.readonlyNotGetVaccine = true;
      vaccinename.clearValidators();
      this.familyinfoForm.get('vaccinename').setValue(null);
      this.familyinfoForm.get('vaccinename').disable();

      this.otherVacFlg = false;
      this.familyinfoForm.get('othvaccinename').clearValidators();
      this.familyinfoForm.get('othvaccinename').setValue('');
    }
    else {
      this.readonlyNotGetVaccine = false;
      vaccinename.setValidators(Validators.required);
      this.familyinfoForm.get('vaccinename').enable();
    }
    vaccinename.updateValueAndValidity();
  }

  enableForOthVacName() {              // create by a
    const othvaccinename = this.familyinfoForm.get('othvaccinename');
    if (this.familyinfoForm.value.vaccinename === 'Other') {
      this.otherVacFlg = true;
      othvaccinename.setValidators(Validators.required);
    }
    else {
      this.otherVacFlg = false;
      othvaccinename.clearValidators();
      this.familyinfoForm.get('othvaccinename').setValue('');
    }
    othvaccinename.updateValueAndValidity();
  }

  candiEmailChkWith() {          // create by a
    //  console.warn(this.userdetails.email)
    const alternativeemail = this.familyinfoForm.get('alternativeemail');
    if (this.userdetails.email === alternativeemail.value) {
      alert("Alternate Email ID cannot be same as Student Email ID");
      alternativeemail.setValue('');
    }

  }

  sbmtDocuments() {              //create by a
    // this.spinner.show();
    this.registrationService.showdoc(this.userdetails.id).then(res => {
      // console.log(res);
      // this.spinner.hide();

      this.selectedFileToShow = res.pndlist;
      // //console.log(this.selectedFileToShow)
      this.selectedFileToShowforMandatory = res.errlist;

      // if (res.status == 'failure') {
      //   for (let i = res.errlist; i < res.errlist.length; i++)
      // }

      // //console.log(res.errlist.length)
      // //console.log(res.status)
      // //console.log(res.mandatorystatus)

      if (res.status == 'success') {
        if (res.mandatorystatus == 'failure') {
          this.showdocuploadModal = false;
          this.mandatoryDialog = true;
        }
        else {
          const dltid = this.dataList.dltid;
          const mask = this.dataList.mask;
          const mobno = this.dataList.mobno;
          const pw = this.dataList.pw;
          const un = this.dataList.un;
          const sub = this.dataList.sub;
          const name = this.dataList.name;
          const emlbody = this.dataList.emlbody;
          const emlpw = this.dataList.emlpw;
          const emlsendto = this.dataList.emlsendto;
          const emlsub = this.dataList.emlsub;
          const emlun = this.dataList.emlun;
          this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
            console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              console.log(error.message);
            });
          if (res.name != '-') {
            this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
              console.log('SMS sent successfully:', response);
            })
          } else {
            console.log(res.msg);
          }
          alert("Documents uploaded successfully");
          this.showdocuploadModal = false;
        }
        if (res.nonmandatorystatus == 'failure') {
          this.docUploadDialog = true;
        }


      } else {
        alert('Please Upload Mandetory Documents');
        // return false;
      }
    }, error => {
      this.spinner.hide();
      alert('Something went wrong.Please try again');
    })
  }


  toggleMarksheet(val: boolean) { //created by a for chekbox of doc upload marksheet
    // console.warn(val);
    if (val) {
      this.marksheetDialogBoxT = true;
      this.marksheetDialogBoxF = false;
    } else {
      this.marksheetDialogBoxF = true;
      this.marksheetDialogBoxT = false;
    }
  }

  toggleMigration(val: boolean) { //created by a for chekbox of doc upload migration certificate
    // console.warn(val);
    if (val) {
      this.migrationDialogBoxT = true;
      this.migrationDialogBoxF = false;
    } else {
      this.migrationDialogBoxF = true;
      this.migrationDialogBoxT = false;
    }
  }


  submitMarksheetmgrchk(val, type) {
    this.spinner.show();
    // console.log(val,type);
    this.registrationService.updateDocDetails(localStorage.getItem('authToken'), val, type)
      .then(data => {
        this.spinner.hide();
        // console.log(data);
        if (data.status === "success") {
          alert(data.msg);
          this.migrationDialogBoxT = false;
          this.migrationDialogBoxF = false;
          this.marksheetDialogBoxT = false;
          this.marksheetDialogBoxF = false;

        //   const dltid = this.dataList.dltid;
        //   const mask = this.dataList.mask;
        //   const mobno = this.dataList.mobno;
        //   const pw = this.dataList.pw;
        //   const un = this.dataList.un;
        //   const sub = this.dataList.sub;
        //   const name = this.dataList.name;
        //   const emlbody = this.dataList.emlbody;
        //   const emlpw = this.dataList.emlpw;
        //   const emlsendto = this.dataList.emlsendto;
        //   const emlsub = this.dataList.emlsub;
        //   const emlun = this.dataList.emlun;
        //   this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
        //     console.log('SMS sent successfully:', response);
        //   })
        //     .catch(error => {
        //       console.log(error.message);
        //     });
        //   if (data.name != '-') {
        //     this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
        //       console.log('SMS sent successfully:', response);
        //     })
        //   } else {
        //     console.log(data.msg);
        //   }
        // } else {
        //   alert(data.msg);
        }
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
  }

  backDialog() {
    this.docUploadDialog = false;
  }

  backforMandatoryField() {
    console.log("Button clicked. Closing dialog.");
    this.mandatoryDialog = false;
    this.showdocuploadModal = true;
  }


  enableOtherDistrictPermanent() {
    const otherresiDistrict = this.familyinfoForm.get('otherresiDistrict');
    if (this.familyinfoForm.value.resiDistrictId == '-1') {
      this.isOtherDistrictPerm = false;
      otherresiDistrict.setValidators([Validators.required]);
    } else {
      this.familyinfoForm.controls.otherresiDistrict.setValue(null);
      this.isOtherDistrictPerm = true;
      otherresiDistrict.clearValidators();
    }
    otherresiDistrict.updateValueAndValidity();
  }

  enableOtherDistrict() {
    const othernewDistrict = this.familyinfoForm.get('othernewDistrict');
    if (this.familyinfoForm.value.newDistrictId == '-1') {
      this.isOtherDistrict = false;
      othernewDistrict.setValidators([Validators.required]);
    } else {
      this.familyinfoForm.controls.othernewDistrict.setValue(null);
      this.isOtherDistrict = true;
      othernewDistrict.clearValidators();
    }
    othernewDistrict.updateValueAndValidity();
  }



}



// WEBPACK FOOTER //
// ./src/app/candidate/dashboard/dashboard.component.ts